/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	var Core = __webpack_require__(1);
	var owl = __webpack_require__(9);
	var spider = __webpack_require__(13);
	var pathTracker = __webpack_require__(15);
	var util = __webpack_require__(2);

	var tryjs = __webpack_require__(8);

	// 注册各种埋点脚本
	var registQueue = [
	    tryjs(function registSpider() {
	        var core = new Core();

	        spider.init(core);

	        // 如果 script 标签没有禁用 spider 自动 pv 上报，则执行自动上报 pv
	        var disabled = util._listDisabledAuto();
	        if (disabled.indexOf('spider') < 0) {  
	            spider.trackPageview();
	        }

	        core.onSpmChange(function () {
	            if (disabled.indexOf('spider') < 0) {  
	                spider.trackPageview();
	            }
	        });

	        window.spider = spider;
	    }, function(err) {
	        spider.reset();
	        window.spider = spider;
	    }),

	    tryjs(function registOwl() {
	        owl.init(new Core());
	        window.owl = owl;
	    }),

	    tryjs(function registPathTracker() {
	        pathTracker.init(new Core());
	        window.pathTracker = pathTracker;
	    })
	];

	for (var i = 0, len = registQueue.length; i < len; i++) {
	    registQueue[i]();
	}

	window.Vcollect = Core;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(2);
	var sha1 = __webpack_require__(4);
	var canvasFp = __webpack_require__(5);
	var console = util._console;

	var pageMetaData = {};
	var COOKIE_KEY_PREFIX = "__spider__"; // cookie 字段，历史原因，性能和埋点均使用该字段;
	var POST_DELAY = 100;
	var REF_URL = "";
	var REPORT_URL = (function () {
	    var hostname = location.hostname;
	    var envMatch = hostname.match(/\.(dev|daily|pre|test)\./);
	    var env = envMatch ? "pre." : "";

	    return "https://thor." + env + "weidian.com/h5collector/web.collect/3.0";
	})();

	// 启动 body-observe
	var bodyObserver = __webpack_require__(6)();

	function _getMetaFromDom() {
	    var head = document.head;
	    var spma = head.querySelector("meta[name='data-spider']") && head.querySelector("meta[name='data-spider']").getAttribute("content");
	    var spmaPrior = head.querySelector("meta[name='data-spider-prior']") && head.querySelector("meta[name='data-spider-prior']").getAttribute("content");
	    var bizVersion = head.querySelector("meta[name='spider-biz-version']") && head.querySelector("meta[name='spider-biz-version']").getAttribute("content");
	    var spmb = document.body.getAttribute("data-spider-prior") || document.body.getAttribute("data-spider");

	    spma = spmaPrior || spma;

	    // if (!spma || !spmb) {
	        // throw new Error("请在页面中正确配置spma、spmb，或在TrackPageview()中传入");
	        // console.warn("[vcollect 提示] 初始页面结构中 dom 节点上没有检测到 spma、spmb 值（监控需要）");
	    // }

	    return {
	        spma: spma,
	        spmb: spmb,
	        bizVersion: bizVersion
	    };
	}

	var visitId = "";
	var total = 0;
	var index = 0;
	var Core = function Core() {
	    this._logQueue = [];
	    this.delayPostTimer = null;

	    this.beforeInitHooks = [];
	    this.afterInitHooks = [];
	    this.beforeReportHooks = [];
	    this.afterReportHooks = [];
	    total++;

	    this.init();

	    var self = this;
	    this.onSpmChange(function(preSpm, curSpm) {
	        // 如果是第一次触发变化，则重置 visitId
	        if (index === 0) {
	            visitId = "";
	        }
	        index++;        
	        self.init();
	        
	        // 如果是最后一次触发变化，则重置 index。便于下次变化重新计数
	        if (index === total) {
	            index = 0;
	        }
	    });
	};

	// 初始化：元数据、cookie、session 等
	Core.prototype.init = function(spma, spmb, bizVersion) {
	    this._runHooks("beforeInit");

	    if (arguments.length === 0) {
	        var meta = _getMetaFromDom();
	        spma = meta.spma;
	        spmb = meta.spmb;
	        bizVersion = meta.bizVersion;
	    }

	    if (!spma || !spmb) {
	        return;
	    }

	    if (!util._isValidSpmValue(spma)) {
	        throw new Error("spm只允许英文、数字、中划线、下划线组成, " + spma + "不合法");
	    }

	    if (!util._isValidSpmValue(spmb)) {
	        throw new Error("spm只允许英文、数字、中划线、下划线组成, " + spmb + "不合法");
	    }

	    // getCookie from piwik-spm's 1.2.0 visitorId
	    var visitorCookieValueOfPiwik = util._getCookie("_pk_id.1.9a21");
	    var visitorIdOfPiwik = visitorCookieValueOfPiwik && visitorCookieValueOfPiwik.split(".")[0];
	    var visitorId = visitorIdOfPiwik || util._getCookie(COOKIE_KEY_PREFIX + "visitorid");
	    var sessionId = util._getCookie(COOKIE_KEY_PREFIX + "sessionid");
	    if (!visitorId) {
	        visitorId = util._generateToken(canvasFp() + (navigator.userAgent || ""));
	    }
	    if (!sessionId) {
	        sessionId = util._generateToken(visitorId);
	    }

	    // update the expires always
	    var cookieStoreDomain = util._getCookieStoreDomain();
	    util._setCookie(COOKIE_KEY_PREFIX + "visitorid", visitorId, {
	        domain: cookieStoreDomain,
	        path: "/",
	        "max-age": 60 * 60 * 24 * 365 * 2
	    });
	    util._setCookie(COOKIE_KEY_PREFIX + "sessionid", sessionId, {
	        domain: cookieStoreDomain,
	        path: "/",
	        "max-age": 60 * 30
	    });

	    visitId = visitId || util._generateToken(visitorId);
	    var buyerId = util._getCookie("WD_b_id") || null;
	    var sellerId = util._getCookie("WD_s_id") || null;

	    pageMetaData = {
	        document_url: document.URL,
	        document_ref: REF_URL || document.referrer || null,
	        visitor_id: visitorId,
	        session_id: sessionId,
	        visit_id: visitId,
	        buyer_id: buyerId,
	        seller_id: sellerId,
	        spma: spma,
	        spmb: spmb,
	        biz_version: bizVersion || "0.0.0",
	    };

	    this._runHooks("afterInit", spma, spmb);
	};

	// 工具方法：数据上报
	Core.prototype.report = function(type, subtype, data) {
	    if (typeof data !== "object" || data === null) {
	        return;
	    }
	    this._runHooks("beforeReport", data);

	    var meta = pageMetaData;
	    var reportData = util._extendObj({}, data, {
	        type: type,
	        subtype: subtype,
	        uuid: util._generateToken(meta.visitorid + meta.visitid),
	        report_time: +new Date()
	    });
	    this._logQueue.push(reportData);

	    if (this._logQueue.length >= 200) {
	        this._postData(type);
	    } else {
	        var self = this;
	        if (this.delayPostTimer === null) {
	            this.delayPostTimer = setTimeout(function() {
	                self._postData(type);
	            }, POST_DELAY);
	        }
	    }
	    this._runHooks("afterReport", reportData);
	};

	Core.prototype._postData = function(type) {  
	    util._post({
	        url: REPORT_URL + "?" + util._queryStringStringify({
	            type: type,
	            spm: [pageMetaData.spma, pageMetaData.spmb].join("."),
	        }),
	        data: {
	            log: util._JSONStringifySafty({
	                meta: pageMetaData,
	                data: this._logQueue
	            })
	        },
	        success: function (res) {
	            if (res && res.status && res.status.code !== 0) {
	                console.warn("上报失败，请检查数据格式是否正确");
	            }
	        }
	    });

	    this._logQueue.length = 0;
	    clearTimeout(this.delayPostTimer);
	    this.delayPostTimer = null;
	};

	// 工具方法：获取元数据
	Core.prototype.getMeta = function() {
	    return pageMetaData;
	};

	// 工具方法：获取上报的 URL
	Core.prototype.getReportUrl = function() {
	    return REPORT_URL;
	};

	// 工具方法：更新 referer
	Core.prototype.updateDocReferrer = function() {
	    REF_URL = location.href;
	};

	// hooks
	Core.prototype.afterInit = function(fn, context) {
	    this.afterInitHooks.push({
	        callback: fn,
	        context: context
	    });
	};
	Core.prototype.beforeInit = function(fn, context) {
	    this.beforeInitHooks.push({
	        callback: fn,
	        context: context
	    });
	};
	Core.prototype.afterReport = function(fn, context) {
	    this.afterReportHooks.push({
	        callback: fn,
	        context: context
	    });
	};
	Core.prototype.beforeReport = function(fn, context) {
	    this.beforeReportHooks.push({
	        callback: fn,
	        context: context
	    });
	};

	Core.prototype.onSpmChange = function (fn) {
	    bodyObserver(function (preSpmb, curSpmb) {
	        var spma = pageMetaData.spma;
	        fn({ spma: spma, spmb: preSpmb }, { spma: spma, spmb: curSpmb });
	    });
	};

	// 私有方法，执行各种 hook
	Core.prototype._runHooks = function (hookName) {
	    var _this = this;
	    var args = [].slice.call(arguments, 1);

	    this[hookName + "Hooks"].forEach(function (hook) {
	        var context = hook.context || _this;
	        if (typeof hook.callback === "function") {
	            hook.callback.apply(context, args);
	        }
	    });
	};

	module.exports = Core;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var SdkLoader = __webpack_require__(3);

	var sha1 = __webpack_require__(4);
	var console = (function() {
	    var ret = {};
	    var noop = function() {};

	    ["log", "info", "warn", "error", "assert",
	        "group", "groupCollapsed", "groupEnd"].forEach(function(propertyName) {
	            try {
	                ret[propertyName] = window.console[propertyName].bind(window.console);
	            } catch (e) {
	                ret[propertyName] = noop;
	            }
	        });

	    return ret;
	})();

	/**
	 * decode string with try catch
	 *
	 * @param {String} str
	 * @returns {String}
	 */
	var decodeURIComponent = function (str) {
	    var ret = "";

	    try {
	        ret = window.decodeURIComponent(str);
	    } catch (e) {
	        // URIERROR
	        console.warn(str + " 无法被 decodeURIComponent，将尝试 unescape");
	    }

	    if (ret === "") {
	        try {
	            ret = window.unescape(str);
	        } catch (e) {
	            console.warn(str + " 无法被 unescape，不进行解码");
	            ret = str;
	        }
	    }

	    return ret;
	};

	/**
	 * _getCookie(key)
	 * @param  {string}  key cookie-key-name
	 * @return {string?}        对应cookie的值，如果该值不存在，返回 null
	 */
	function _getCookie(key) {
	    var splitToken = "; ";

	    var ret = {};
	    if (document.cookie !== "") {
	        document.cookie.split(splitToken).forEach(function (entry) {
	            var arr = entry.split("=");
	            ret[decodeURIComponent(arr[0])] = decodeURIComponent(arr[1] || "");
	        });
	    }

	    return arguments.length === 0 ? ret : ret[key] || null;
	}

	// https://developer.mozilla.org/en-US/docs/Web/API/document/cookie
	function _setCookie(key, value, options) {
	    options = options || {};

	    var arr = [];
	    arr.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
	    for (var optionKey in options) {
	        arr.push(optionKey + "=" + options[optionKey]);
	    }
	    document.cookie = arr.join("; ");
	}

	function _delCookie(key, options) {
	    var arr = [];
	    var exp = new Date();
	    exp.setTime(exp.getTime() - 1);

	    if (_getCookie(key)) {
	        arr.push(encodeURIComponent(key) + "=a");
	        for (var optionKey in options) {
	            arr.push(optionKey + "=" + options[optionKey]);
	        }
	        arr.push("max-age=" + 0);
	        document.cookie = arr.join("; ");
	    } else {
	        return;
	    }
	}

	/**
	 * _queryStringParse
	 * @param  {Querystring} querystring already encoded by encodeURIComponent
	 * @return {PlainObjectNotNested} already decoded by decodeURIComponent
	 */
	function _queryStringParse(querystring) {
	    var ret = {};

	    querystring = querystring.replace(/^\?/, "");

	    if (querystring !== "") {
	        querystring.split("&").forEach(function (entry) {
	            var arr = entry.split("=");
	            if (!arr[0]) return;
	            ret[decodeURIComponent(arr[0])] = decodeURIComponent(arr[1] || "");
	        });
	    }

	    return ret;
	}

	/**
	 * _queryStringStringify
	 * @param  {PlainObjectNotNested} query
	 * @return {Querystring}
	 */
	function _queryStringStringify(query) {
	    var arr = [];
	    var validType = ["string", "boolean", "number"];
	    for (var key in query) {
	        if (key === "") continue;
	        if (validType.indexOf(typeof query[key]) > -1) {
	            switch (query[key]) {
	                case true:
	                case "":
	                    arr.push(encodeURIComponent(key));
	                    break;
	                case false:
	                    break;
	                default:
	                    arr.push(encodeURIComponent(key) + "=" + encodeURIComponent(query[key]));
	            }
	        }
	    }
	    return arr.length === 0 ? "" : arr.join("&");
	}

	// https://developer.mozilla.org/en-US/docs/Web/API/location
	function _urlParse(url) {
	    var anchor = document.createElement("a");
	    anchor.href = url;
	    return anchor;
	}

	function _post(options) {
	    var xmlhttp = new window.XMLHttpRequest();
	    xmlhttp.onreadystatechange = function () {
	        if (4 == xmlhttp.readyState) {
	            if (200 == xmlhttp.status) {
	                var data = xmlhttp.responseText;
	                options.success(_JSONParseSafty(data));
	            } else {
	                options.error && options.error();
	            }
	        }
	    };
	    xmlhttp.open("POST", options.url, true);
	    xmlhttp.withCredentials = true;
	    if (options) {
	        xmlhttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
	        xmlhttp.setRequestHeader("Accept", "application/json", "text/plain, */*");
	    }
	    if (!(options.data instanceof FormData)) {
	        options.data = _queryStringStringify(options.data);
	    }
	    xmlhttp.send(options.data);
	}

	function _isValidSpmValue(str) {
	    var reg = /^[a-zA-Z0-9\-\_]+$/;

	    if (String(str).match(reg) === null) {
	        return false;
	    } else {
	        return true;
	    }
	}

	function _getCookieStoreDomain(hostname) {
	    hostname = hostname || location.hostname;
	    // leadingDot here is for browser compatibility
	    var leadingDot = ".";

	    // 三级域名以下解决方案
	    var subDomains = _get2ndLevelDomain(hostname);
	    var cookieDomain = leadingDot + subDomains;


	    // 多级域名下解决方案
	    // var hostnameLayer = hostname.split(".");
	    // if (hostnameLayer.length === 2) {
	    //     cookieDomain = leadingDot + hostname;
	    // }

	    // if (hostnameLayer.length > 2) {
	    //     cookieDomain = leadingDot + hostnameLayer.slice(1).join(".");
	    // }

	    return cookieDomain;
	}

	function _get2ndLevelDomain(hostname) {
	    return hostname.split(".").slice(-2).join(".");
	}

	function _extendObj(target, varArgs) {
	    var to = Object(target);
	    for (var index = 1; index < arguments.length; index++) {
	        var nextSource = arguments[index];

	        // Skip over if undefined or null
	        if (nextSource != null) {
	            for (var nextKey in nextSource) {
	                // Avoid bugs when hasOwnProperty is shadowed
	                if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
	                    to[nextKey] = nextSource[nextKey];
	                }
	            }
	        }
	    }
	    return to;
	}

	function _generateToken(salt, bits) {
	    salt = salt || "";
	    bits = bits || 16;

	    var now = new Date();
	    var token = sha1(
	        now.getTime() + Math.random() + salt
	    ).slice(0, bits);

	    return token;
	}

	function _getStorageItemSafty(key) {
	    try {
	        var item = sessionStorage.getItem(key);
	        return item;
	    } catch (e) {
	        console.error("sessionStorage 不可用");
	        return "";
	    }
	}

	function _setStorageItemSafty(key, item) {
	    try {
	        sessionStorage.setItem(key, item);
	    } catch (e) {
	        console.error("sessionStorage 不可用");
	    }
	}

	function _isObjectAndNotNull(obj) {
	    if (typeof obj !== "object") return false;
	    if (obj === null) return false;
	    return true;
	}

	function _isEmptyObject(obj) {
	    console.assert(typeof obj === "object", "必须是一个object");
	    if (obj === null) return false;
	    if (Object.keys(obj).length === 0) {
	        return true;
	    } else {
	        return false;
	    }
	}

	function _JSONStringifySafty(obj) {
	    if (!_isObjectAndNotNull(obj)) return "";
	    if (_isEmptyObject(obj)) return "";
	    try {
	        return JSON.stringify(obj);
	    } catch (e) {
	        console.warn("非法JSON对象，无法进行 JSON.stringify");
	        return "";
	    }
	}

	// always return a non-null object
	function _JSONParseSafty(str) {
	    // JSON.parse may throw error, return primitive, return null
	    try {
	        var val = JSON.parse(str);
	        if (typeof val === "object" && val !== null) {
	            return val;
	        } else {
	            return {};
	        }
	    } catch (err) {
	        console.warn("非法JSON字符串，无法进行 JSON.parse");
	        return {};
	    }
	}

	function _closestElementUntilBody(startElement, matcher) {
	    var target = startElement;
	    while (target !== null) {
	        if (target === document.body) return null;
	        if (target === document.documentElement) return null;
	        if (matcher(target)) return target;

	        target = target.parentNode;
	    }

	    // elem.parentNode may return null
	    // @see http://devdocs.io/dom/node/parentnode
	    return null;
	}

	// var camelizeRE = /-(\w)/g;
	// function _camelize(str) {
	//     return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ""; });
	// }

	function _listCustomPlugin() {
	    // var currentScript = document.currentScript || document.querySelector("[data-vcollect-plugin]");
	    // var plugins = currentScript && currentScript.dataset.vcollectPlugin;
	    // var currentScript = document.currentScript || document.querySelector("[data-vcollect-plugin]");
	    var plugins = document.body.dataset.vcollectPlugin;
	    return plugins ? plugins.split(",") : [];
	}

	function _listDisabledAuto() {
	    // var currentScript = document.currentScript || document.querySelector("[data-vcollect-disabled]");
	    // var disabled = currentScript && currentScript.dataset.vcollectDisabled;

	    // var currentScript = document.currentScript || document.querySelector("[data-vcollect-disabled]");
	    var disabled = document.body.dataset.vcollectDisabled;
	    return disabled ? disabled.split(",") : [];
	}

	function _getNetwork(callback) {
	    if (typeof SdkLoader !== "function") {
	        console.warn("请引入 v-components/sdk-loader，用于获取网络状态!");
	        return callback(null);
	    }

	    SdkLoader().ready(function (env) {
	        if (env === "wx") {
	            window.wx && window.wx.getNetworkType({
	                success: function (res) {
	                    callback(res.networkType);
	                },
	                fail: function () {
	                    callback(null);
	                }
	            });
	        } else if (env === "app") {
	            window.KDJSBridge2 && window.KDJSBridge2.call("WDJSBridge", "getNetworkStatus", {}, function (res) {
	                var maps = {
	                    "2": "wifi",
	                    "3": "2g",
	                    "4": "3g",
	                    "5": "4g"
	                };
	                if (res && res.param && res.param.network) {
	                    callback(maps[res.param.network]);
	                } else {
	                    callback(null);
	                }
	            });
	        } else {
	            callback(null);
	        }
	    });
	}


	module.exports = {
	    _console: console,
	    _post: _post,
	    _getCookie: _getCookie,
	    _setCookie: _setCookie,
	    _delCookie: _delCookie,
	    _queryStringStringify: _queryStringStringify,
	    _queryStringParse: _queryStringParse,
	    _isValidSpmValue: _isValidSpmValue,
	    _getCookieStoreDomain: _getCookieStoreDomain,
	    _extendObj: _extendObj,
	    _generateToken: _generateToken,
	    _sha1: sha1,
	    _getStorageItemSafty: _getStorageItemSafty,
	    _setStorageItemSafty: _setStorageItemSafty,
	    _JSONParseSafty: _JSONParseSafty,
	    _JSONStringifySafty: _JSONStringifySafty,
	    _urlParse: _urlParse,
	    _isObjectAndNotNull: _isObjectAndNotNull,
	    _isEmptyObject: _isEmptyObject,
	    _listCustomPlugin: _listCustomPlugin,
	    _listDisabledAuto: _listDisabledAuto,
	    _getNetwork: _getNetwork,
	    _noop: function() {}
	};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	!(function(factory) {
	    if (typeof module !== "undefined" && module.exports) {
	        module.exports = factory();
	    } else {
	        window.SdkLoader = factory();
	    }
	}(function() {
	    function Loader() {
	        this._init();
	        var self = this;

	        return function() {
	            return self;
	        };
	    }

	    (function() {
	        var wxSDK = "//assets.geilicdn.com/v-components/cdn/jweixin/1.3.2/index.fix.min.js",
	            qqSDK = "//assets.geilicdn.com/v-components/cdn/qqsdk/default/index.fix.min.js",
	            qqBrowserServer = "//jsapi.qq.com/get?api=app.share",
	            kdjsbridge2 = "https://s.geilicdn.com/script/common/jsbridge.min.js";

	        this._init = function() {
	            this.isReady = false;
	            this.callbackList = [];

	            this._env = this._decideEnv();
	            this._loadEnv();
	        };

	        this.ready = function(cb) {
	            if (this.isReady) {
	                cb(this._env);
	                return;
	            }
	            this.callbackList.push(cb);
	        };

	        this.wxApiList = [
	            "onMenuShareTimeline",
	            "onMenuShareAppMessage",
	            "onMenuShareQQ",
	            "onMenuShareQZone",
	            "hideMenuItems",
	            "chooseImage",
	            "getLocalImgData",
	            "previewImage",
	            "downloadImage",
	            "openLocation",
	            "getLocation",
	            "hideMenuItems",
	            "launch3rdApp",
	            "getInstallState",
	            "uploadImage"
	        ];

	        this._decideEnv = function() {
	            var ua = window.navigator.userAgent;        
	            var env = "browser";
	            /MQQBrowser\//i.test(ua) && (env = "qqbrowser");
	            /MicroMessenger/i.test(ua) && (env = "wx");
	            /QQ\/([\d\.]+)/i.test(ua) && (env = "qq");
	            /WDAPP\(/.test(ua) && (env = "app");            
	            /WDAPP\(WDBuyer/.test(ua) && (env = "vbuyer");
	            /WDAPP\(WD\//.test(ua) && (env = "kdweidian");

	            return env;
	        };

	        this._loadEnv = function() {
	            var self = this;
	            var env = self._env;

	            var sdkMap = {
	                wx: wxSDK,
	                qq: qqSDK,
	                qqbrowser: qqBrowserServer,
	                app: kdjsbridge2,
	                kdweidian: kdjsbridge2,
	                vbuyer: kdjsbridge2,
	                browser: ""
	            };

	            if (env === "wx" && typeof window.wx === "object") {
	                wx.ready(function() {
	                    self._callback();
	                });         
	                return;
	            }

	            var sdk = sdkMap[env];
	            loadJs(sdk, function() {
	                if (env == "wx") {
	                    self._initWeixinSDK();
	                    return;
	                }
	                self._callback();
	            });
	        };


	        this._initWeixinSDK = function() {
	            var self = this,
	                url = "https://vap.gw.weidian.com/h5/weixin/getjsconfig/1.0?url=" + encodeURIComponent(location.href) + "&mpid=gh_c6feb778444d";

	            self._ajax(url, function(res) {                    
	                if (res.status.code == 0) {
	                    var args = res.result;
	                    // 配置微信JS-SDK
	                    window.wx && window.wx.config({
	                        beta: true,
	                        debug: false,
	                        appId: args.appId,
	                        timestamp: args.timestamp,
	                        nonceStr: args.nonceStr,
	                        signature: args.signature,
	                        jsApiList: self.wxApiList
	                    });
	                    window.wx && window.wx.ready(function() {
	                        self._callback();
	                    });
	                }
	            });
	        };

	        this._callback = function() {
	            var callbackList = this.callbackList;
	            var env = this._env;
	            callbackList.forEach(function(cb) {
	                cb(env);
	            });
	            this.callbackList = [];
	            this.isReady = true;
	        };

	        this._ajax = function (url, callback) {
	            var xhr = new XMLHttpRequest();
	            xhr.onload = function () {
	                if (this.status >= 200 && this.status < 300 || xhr.status == 304) {
	                    try {
	                        callback && callback(JSON.parse(this.response));  
	                    } catch (e) {}
	                }
	            };
	            xhr.open("POST", url, true);
	            xhr.setRequestHeader("Accept", "application/json, text/plain, */*");
	            xhr.send();
	        };

	        function loadJs(src, cb) {
	            if (!src) {
	                cb();
	                return;
	            }

	            var script = document.createElement("script");
	            script.src = src;
	            script.addEventListener("load", function() {
	                cb();
	            });
	            document.getElementsByTagName("head")[0].appendChild(script);
	        }

	    }).call(Loader.prototype);

	    return new Loader();
	}));

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	/*
	* https://raw.githubusercontent.com/kvz/locutus/master/src/php/strings/sha1.js 
	*/
	function sha1(str) {
	    var hash;

	    var _rotLeft = function(n, s) {
	        var t4 = (n << s) | (n >>> (32 - s));
	        return t4;
	    };

	    var _cvtHex = function(val) {
	        var str = "";
	        var i;
	        var v;

	        for (i = 7; i >= 0; i--) {
	            v = (val >>> (i * 4)) & 0x0f;
	            str += v.toString(16);
	        }
	        return str;
	    };

	    var blockstart;
	    var i, j;
	    var W = new Array(80);
	    var H0 = 0x67452301;
	    var H1 = 0xEFCDAB89;
	    var H2 = 0x98BADCFE;
	    var H3 = 0x10325476;
	    var H4 = 0xC3D2E1F0;
	    var A, B, C, D, E;
	    var temp;

	    // utf8_encode
	    str = unescape(encodeURIComponent(str));
	    var strLen = str.length;

	    var wordArray = [];
	    for (i = 0; i < strLen - 3; i += 4) {
	        j = str.charCodeAt(i) << 24 | str.charCodeAt(i + 1) << 16 | str.charCodeAt(i + 2) << 8 | str.charCodeAt(i + 3);
	        wordArray.push(j);
	    }

	    switch (strLen % 4) {
	        case 0:
	            i = 0x080000000;
	            break;
	        case 1:
	            i = str.charCodeAt(strLen - 1) << 24 | 0x0800000;
	            break;
	        case 2:
	            i = str.charCodeAt(strLen - 2) << 24 | str.charCodeAt(strLen - 1) << 16 | 0x08000;
	            break;
	        case 3:
	            i = str.charCodeAt(strLen - 3) << 24 | str.charCodeAt(strLen - 2) << 16 | str.charCodeAt(strLen - 1) << 8 | 0x80;
	            break;
	    }

	    wordArray.push(i);

	    while ((wordArray.length % 16) !== 14) {
	        wordArray.push(0);
	    }

	    wordArray.push(strLen >>> 29);
	    wordArray.push((strLen << 3) & 0x0ffffffff);

	    for (blockstart = 0; blockstart < wordArray.length; blockstart += 16) {
	        for (i = 0; i < 16; i++) {
	            W[i] = wordArray[blockstart + i];
	        }
	        for (i = 16; i <= 79; i++) {
	            W[i] = _rotLeft(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
	        }

	        A = H0;
	        B = H1;
	        C = H2;
	        D = H3;
	        E = H4;

	        for (i = 0; i <= 19; i++) {
	            temp = (_rotLeft(A, 5) + ((B & C) | (~B & D)) + E + W[i] + 0x5A827999) & 0x0ffffffff;
	            E = D;
	            D = C;
	            C = _rotLeft(B, 30);
	            B = A;
	            A = temp;
	        }

	        for (i = 20; i <= 39; i++) {
	            temp = (_rotLeft(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ED9EBA1) & 0x0ffffffff;
	            E = D;
	            D = C;
	            C = _rotLeft(B, 30);
	            B = A;
	            A = temp;
	        }

	        for (i = 40; i <= 59; i++) {
	            temp = (_rotLeft(A, 5) + ((B & C) | (B & D) | (C & D)) + E + W[i] + 0x8F1BBCDC) & 0x0ffffffff;
	            E = D;
	            D = C;
	            C = _rotLeft(B, 30);
	            B = A;
	            A = temp;
	        }

	        for (i = 60; i <= 79; i++) {
	            temp = (_rotLeft(A, 5) + (B ^ C ^ D) + E + W[i] + 0xCA62C1D6) & 0x0ffffffff;
	            E = D;
	            D = C;
	            C = _rotLeft(B, 30);
	            B = A;
	            A = temp;
	        }

	        H0 = (H0 + A) & 0x0ffffffff;
	        H1 = (H1 + B) & 0x0ffffffff;
	        H2 = (H2 + C) & 0x0ffffffff;
	        H3 = (H3 + D) & 0x0ffffffff;
	        H4 = (H4 + E) & 0x0ffffffff;
	    }

	    temp = _cvtHex(H0) + _cvtHex(H1) + _cvtHex(H2) + _cvtHex(H3) + _cvtHex(H4);
	    return temp.toLowerCase();
	}

	module.exports = sha1;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	// https://www.browserleaks.com/canvas#how-does-it-work
	function getCanvasFootPrint () {
	    var canvas = document.createElement("canvas");
	    canvas.width = 2000;
	    canvas.height = 200;
	    canvas.style.display = "inline";
	    var ctx = canvas.getContext("2d");

	    ctx.textBaseline = "alphabetic";

	    ctx.fillStyle = "#f60";
	    ctx.fillRect(125, 1, 62, 20);

	    ctx.fillStyle = "#069";
	    ctx.font = "11pt Arial";
	    ctx.fillText("Cwm fjordbank glyphs vext quiz, \ud83d\ude03", 2, 15);

	    ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
	    ctx.font = "18pt Arial";
	    ctx.fillText("Cwm fjordbank glyphs vext quiz, \ud83d\ude03", 4, 45);

	    return canvas.toDataURL();
	}

	module.exports = getCanvasFootPrint;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(7);

	module.exports = function () {
	    var MutaionObserver = window.MutaionObserver;
	    var tryjs = __webpack_require__(8);
	    
	    var DATA_SPIDER = "data-spider";
	    var DATA_SPIDER_PRIOR = "data-spider-prior";

	    var body = document.body;
	    var curAttrValue;
	    var preAttrValue = body.getAttribute(DATA_SPIDER_PRIOR) || body.getAttribute(DATA_SPIDER); // 初始化为当前数据

	    var callbacks = [];

	    var observer = new MutationObserver(tryjs(function (mutations) {
	        mutations.forEach(function (record) {
	            if (record.type == "attributes") {
	                var attrName = record.attributeName;
	                if (attrName === DATA_SPIDER_PRIOR || attrName === DATA_SPIDER) {
	                    curAttrValue = body.getAttribute(DATA_SPIDER_PRIOR) || body.getAttribute(DATA_SPIDER);

	                    // console.log("监听到 body 属性变化， pre: ", preAttrValue, " cur: ", curAttrValue);
	                    if (curAttrValue && (curAttrValue !== preAttrValue)) {
	                        // callback
	                        for (var i = 0; i < callbacks.length; i++) {
	                            callbacks[i](preAttrValue, curAttrValue);
	                        }
	                    }

	                    preAttrValue = curAttrValue;
	                }
	            }
	        });
	    }));

	    observer.observe(body, { attributes: true });

	    return function (fn) {
	        callbacks.push(fn);
	    };  
	};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	// mutationobserver-shim v0.3.2 (github.com/megawac/MutationObserver.js)
	// Authors: Graeme Yeates (github.com/megawac) 
	window.MutationObserver=window.MutationObserver||function(w){function v(a){this.i=[];this.m=a}function I(a){(function c(){var d=a.takeRecords();d.length&&a.m(d,a);a.h=setTimeout(c,v._period)})()}function p(a){var b={type:null,target:null,addedNodes:[],removedNodes:[],previousSibling:null,nextSibling:null,attributeName:null,attributeNamespace:null,oldValue:null},c;for(c in a)b[c]!==w&&a[c]!==w&&(b[c]=a[c]);return b}function J(a,b){var c=C(a,b);return function(d){var f=d.length,n;b.a&&3===a.nodeType&&
	a.nodeValue!==c.a&&d.push(new p({type:"characterData",target:a,oldValue:c.a}));b.b&&c.b&&A(d,a,c.b,b.f);if(b.c||b.g)n=K(d,a,c,b);if(n||d.length!==f)c=C(a,b)}}function L(a,b){return b.value}function M(a,b){return"style"!==b.name?b.value:a.style.cssText}function A(a,b,c,d){for(var f={},n=b.attributes,k,g,x=n.length;x--;)k=n[x],g=k.name,d&&d[g]===w||(D(b,k)!==c[g]&&a.push(p({type:"attributes",target:b,attributeName:g,oldValue:c[g],attributeNamespace:k.namespaceURI})),f[g]=!0);for(g in c)f[g]||a.push(p({target:b,
	type:"attributes",attributeName:g,oldValue:c[g]}))}function K(a,b,c,d){function f(b,c,f,k,y){var g=b.length-1;y=-~((g-y)/2);for(var h,l,e;e=b.pop();)h=f[e.j],l=k[e.l],d.c&&y&&Math.abs(e.j-e.l)>=g&&(a.push(p({type:"childList",target:c,addedNodes:[h],removedNodes:[h],nextSibling:h.nextSibling,previousSibling:h.previousSibling})),y--),d.b&&l.b&&A(a,h,l.b,d.f),d.a&&3===h.nodeType&&h.nodeValue!==l.a&&a.push(p({type:"characterData",target:h,oldValue:l.a})),d.g&&n(h,l)}function n(b,c){for(var g=b.childNodes,
	q=c.c,x=g.length,v=q?q.length:0,h,l,e,m,t,z=0,u=0,r=0;u<x||r<v;)m=g[u],t=(e=q[r])&&e.node,m===t?(d.b&&e.b&&A(a,m,e.b,d.f),d.a&&e.a!==w&&m.nodeValue!==e.a&&a.push(p({type:"characterData",target:m,oldValue:e.a})),l&&f(l,b,g,q,z),d.g&&(m.childNodes.length||e.c&&e.c.length)&&n(m,e),u++,r++):(k=!0,h||(h={},l=[]),m&&(h[e=E(m)]||(h[e]=!0,-1===(e=F(q,m,r,"node"))?d.c&&(a.push(p({type:"childList",target:b,addedNodes:[m],nextSibling:m.nextSibling,previousSibling:m.previousSibling})),z++):l.push({j:u,l:e})),
	u++),t&&t!==g[u]&&(h[e=E(t)]||(h[e]=!0,-1===(e=F(g,t,u))?d.c&&(a.push(p({type:"childList",target:c.node,removedNodes:[t],nextSibling:q[r+1],previousSibling:q[r-1]})),z--):l.push({j:e,l:r})),r++));l&&f(l,b,g,q,z)}var k;n(b,c);return k}function C(a,b){var c=!0;return function f(a){var k={node:a};!b.a||3!==a.nodeType&&8!==a.nodeType?(b.b&&c&&1===a.nodeType&&(k.b=G(a.attributes,function(c,f){if(!b.f||b.f[f.name])c[f.name]=D(a,f);return c})),c&&(b.c||b.a||b.b&&b.g)&&(k.c=N(a.childNodes,f)),c=b.g):k.a=
	a.nodeValue;return k}(a)}function E(a){try{return a.id||(a.mo_id=a.mo_id||H++)}catch(b){try{return a.nodeValue}catch(c){return H++}}}function N(a,b){for(var c=[],d=0;d<a.length;d++)c[d]=b(a[d],d,a);return c}function G(a,b){for(var c={},d=0;d<a.length;d++)c=b(c,a[d],d,a);return c}function F(a,b,c,d){for(;c<a.length;c++)if((d?a[c][d]:a[c])===b)return c;return-1}v._period=30;v.prototype={observe:function(a,b){for(var c={b:!!(b.attributes||b.attributeFilter||b.attributeOldValue),c:!!b.childList,g:!!b.subtree,
	a:!(!b.characterData&&!b.characterDataOldValue)},d=this.i,f=0;f<d.length;f++)d[f].s===a&&d.splice(f,1);b.attributeFilter&&(c.f=G(b.attributeFilter,function(a,b){a[b]=!0;return a}));d.push({s:a,o:J(a,c)});this.h||I(this)},takeRecords:function(){for(var a=[],b=this.i,c=0;c<b.length;c++)b[c].o(a);return a},disconnect:function(){this.i=[];clearTimeout(this.h);this.h=null}};var B=document.createElement("i");B.style.top=0;var D=(B="null"!=B.attributes.style.value)?L:M,H=1;return v}(void 0);
	//# sourceMappingURL=mutationobserver.map


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = function(fn, backupFn) {
	    return function() {
	        try {
	            fn.apply(this, arguments);
	        } catch(err) {
	            console.warn('vcollect err: ', err);

	            if (!backupFn || typeof backupFn !== 'function') {
	                return;
	            }

	            var args = Array.prototype.slice.call(arguments, 0);
	            args.unshift(err);

	            backupFn.apply(this, args);
	        }
	    };
	};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var log = __webpack_require__(10);
	var performanceAuto = __webpack_require__(11);

	module.exports = {
	    log: log,
	    perf: performanceAuto,
	    init: function (core) {
	        this.log.install.call(this.log, core);
	        this.perf.install.call(this.perf, core);
	    },

	    core: {
	        init: function() {
	            // 空方法，用于兼容老式写法 owl.core.init()
	        }
	    }
	};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * see: https://developer.mozilla.org/en-US/docs/Web/API/ErrorEvent
	 * see: https://www.w3.org/TR/html5/webappapis.html#the-errorevent-interface
	 */

	"use strict";

	var util = __webpack_require__(2);

	var log = {};
	var console = util._console;
	var necessaryKeys = [
	    "message",
	    "url",
	    "name",
	];

	//提前定义接口函数
	log.error = util._noop;
	log.warn = util._noop;
	log.info = util._noop;
	log.debug = util._noop;

	//@core install
	log.install = function(core) {
	    var reportUrl = core.getReportUrl();

	    var logError = function(data) {
	        _log("error", data);
	    };
	    var logWarn = function(data) {
	        _log("warn", data);
	    };
	    var logDebug = function(data) {
	        _log("debug", data);
	    };
	    var logInfo = function(data) {
	        _log("info", data);
	    };

	    function _log(subtype, data) {        
	        data = data || {};
	        util._getNetwork(function(network) {
	            util._extendObj(data.detail, {network: network});
	            core.report("log", subtype, _normalizeLog(data));
	        });
	    }

	    function _normalizeLog(data) {
	        necessaryKeys.forEach(function (key) {
	            if (data[key] === "" || data[key] === undefined) {
	                data[key] = null;
	                return;
	            }
	        });

	        var detail = data.detail;
	        if (_isObjectAndNotEmpty(detail)) {
	            Object.keys(detail).forEach(function (secondKey) {
	                if (detail[secondKey] === "") {
	                    detail[secondKey] = null;
	                }
	            });
	        } else {
	            data.detail = {};
	        }

	        var originalUrl = data.url || location.href;
	        data.url = _cutQuerystringAndHash(originalUrl);
	        data.detail.originalUrl = originalUrl;

	        return data;
	    }

	    function _cutQuerystringAndHash(url) {
	        if (/\?\?/.test(url)) {
	            return url.replace(/#\S+,/, ",").replace(/#\S+$/, "");
	        }
	        return url.replace(/[#\?]\S+$/, "");
	    }

	    function _isObjectAndNotEmpty(obj) {
	        if (typeof obj !== "object") return false;
	        if (obj === null) return false;
	        if (Object.keys(obj).length === 0) return false;
	        return true;
	    }

	    function _isUploadAPI(url) {
	        return url.indexOf(reportUrl) >= 0;
	    }

	    function _listenXhrResponse(xhr) {
	        var requestUrl = xhr._http.url;

	        setTimeout(function() {
	            if (xhr.readyState !== xhr.DONE) {
	                logWarn({
	                    name: "__XHR__",
	                    url: requestUrl,
	                    message: "slow-response",
	                });
	            }
	        }, 3000);

	        xhr.addEventListener("load", function() {
	            var res = {};
	            if (xhr.response) {
	                res = util._JSONParseSafty(xhr.response);
	            }

	            if (res && res.status && res.status.code !== 0) {
	                logError({
	                    name: "__XHR__",
	                    url: requestUrl,
	                    message: "response-unexpect",
	                    detail: {
	                        status: util._JSONStringifySafty(res.status)
	                    }
	                });
	            }
	        });

	        // see: https://xhr.spec.whatwg.org/#events
	        xhr.addEventListener("error", function(e) {
	            logError({
	                name: "__XHR__",
	                url: requestUrl,
	                message: "response-error",
	            });
	        });
	        xhr.addEventListener("abort", function() {
	            logWarn({
	                name: "__XHR__",
	                url: requestUrl,
	                message: "response-abort",
	            });
	        });
	        xhr.addEventListener("timeout", function() {
	            logError({
	                name: "__XHR__",
	                url: requestUrl,
	                message: "response-timeout",
	            });
	        });
	    }

	    function _overrideXhr() {
	        var XhrProto = XMLHttpRequest.prototype;
	        XhrProto._open = XhrProto.open;
	        XhrProto.open = function(method, url) {
	            this._http = this._http || {};
	            this._http.method = method;
	            this._http.url = url;
	            return XhrProto._open.apply(this, [].slice.call(arguments));
	        };
	        XhrProto._send = XhrProto.send;
	        XhrProto.send = function() {
	            var xhr = this;
	            if (!_isUploadAPI(xhr._http.url)) {
	                _listenXhrResponse(xhr);
	            }
	            return XhrProto._send.apply(this, [].slice.call(arguments));
	        };
	    }

	    _overrideXhr();

	    function _deriveFromErrorEvent(evt) {
	        // 需要业务方在 script 标签上标记 crossorigin 才能获得详细错误信息
	        var error = evt.error;
	        if (!error) {
	            console.warn("需要业务方在 script 标签上标记 crossorigin 才能获得详细错误信息");
	            return null;
	        }

	        return {
	            message: error.message,
	            url: evt.filename,
	            name: "__WINDOW_ERROR__",
	            detail: {
	                stack: error.stack,
	                lineno: evt.lineno,
	                colno: evt.colno
	            }
	        };
	    }

	    window.addEventListener("error", function(evt) {
	        var error = _deriveFromErrorEvent(evt);
	        
	        if (error) {
	            logError(error);
	        }
	    });

	    log.error = logError;
	    log.warn = logWarn;
	    log.info = logInfo;
	    log.debug = logDebug;
	};

	module.exports = log;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	var autoFirstScreen = __webpack_require__(12);
	var util = __webpack_require__(2);

	// 一些模块级全局变量
	var perf = {};
	var win = window;
	var doc = win.document;
	var performance = win.performance;

	var scriptStartTime = Date.now();

	// 初始化各种 API
	function initUserTimingAPI(core) {
	    if (!performance) return;

	    var _originalMark = function (name) {
	        performance.mark(name);
	        var data = performance.getEntriesByName(name, "mark").pop();
	        _reportUserTiming(data);
	    };

	    var _mockMark = function (name) {
	        var data = {
	            duration: 0,
	            entryType: "mark",
	            name: name,
	            startTime: _getHighResolutionTime()
	        };

	        _mockMarkQueue.push(data);
	        _reportUserTiming(data);
	    };

	    var _originalMeasure = function (name, startMark, endMark) {
	        performance.measure(name, startMark, endMark);
	        var data = performance.getEntriesByName(name, "measure").pop();
	        _reportUserTiming(data);
	    };

	    var _mockMeasure = function (name, startMark, endMark) {
	        var startTime, endTime, duration;
	        var mockMarkQueue = _mockMarkQueue;

	        if (startMark === undefined) {
	            startTime = 0;
	        } else {
	            startTime = mockMarkQueue._getMarkStartTime(startMark);
	        }

	        if (endMark === undefined) {
	            endTime = _getHighResolutionTime();
	        } else {
	            endTime = mockMarkQueue._getMarkStartTime(endMark);
	        }

	        duration = endTime - startTime;
	        var data = {
	            duration: duration,
	            entryType: "measure",
	            name: name,
	            startTime: startTime
	        };
	        _reportUserTiming(data);
	    };

	    var _reportUserTiming = function (data) {
	        util._getNetwork(function (network) {
	            data.network = network;
	            var plainData = _source2plainObject(data);
	            core.report("performance", "userTiming", plainData);
	        });
	    };

	    var _mockMarkQueue = {
	        push: function (data) {
	            this._markCache.push(data);
	        },
	        _markCache: [],
	        _getMarkStartTime: function (name) {
	            var startTime;
	            this._markCache.forEach(function (mark, index) {
	                if (mark.name === name) {
	                    startTime = mark.startTime;
	                }
	            });
	            return startTime;
	        },
	    };

	    function _getHighResolutionTime() {
	        if (typeof performance.now === "function") return performance.now();
	        return Date.now() - performance.timing.navigationStart;
	    }

	    this.mark = (function () {
	        if (typeof performance.mark === "function") {
	            return _originalMark;
	        }
	        return _mockMark;
	    })();

	    this.measure = (function () {
	        if (typeof performance.measure === "function") {
	            return _originalMeasure;
	        }

	        return _mockMeasure;
	    })();
	}

	// 运行主要函数（巨型函数）
	function runPerf(core) {
	    //提前定义接口函数，规避兼容性问题
	    this.recordFirstScreen = function () { };
	    this.docRetrieveStart = function () { };
	    this.docRetrieveEnd = function () { };
	    this.onRecord = false;

	    if (!performance || performance.timing == undefined) return;

	    var _perfQueue = {
	        _firstScreenLoadStart: 0,
	        _firstScreenLoadEnd: 0,
	        _resourceTiming: [],
	        _pageTiming: null,
	        reportData: function (/*otherResult*/) {
	            var self = this;

	            util._getNetwork(function (network) {
	                var counts = {
	                    xhrCounts: 0,
	                    cssCounts: 0,
	                    imgCounts: 0,
	                    jsCounts: 0,
	                    resourceCounts: 0
	                };

	                // 处理 resourceTiming
	                self._resourceTiming.forEach(function (resource) {
	                    if (resource.name.search("web.collect") > -1) {
	                        return;
	                    }

	                    _recordResourceType.call(counts, resource);
	                    // _recordResourceSize.call(size, resource);
	                    resource.network = network;

	                    var plainData = _source2plainObject(resource);
	                    core.report("performance", "resourceTiming", plainData);
	                });

	                // 处理 pageTiming
	                var pageTiming = self._pageTiming;

	                if (counts.resourceCounts > 50) {
	                    console.warn("首屏资源数量大于50，请检查数据上报是否正常");
	                }
	                for (var countsKey in counts) {
	                    pageTiming[countsKey] = counts[countsKey];
	                }

	                pageTiming.firstScreenLoadStart = self._firstScreenLoadStart;
	                pageTiming.firstScreenLoadEnd = self._firstScreenLoadEnd;
	                pageTiming.network = network;
	                pageTiming.firstScreen = self._firstScreenLoadEnd - pageTiming.navigationStart;
	                var plainData = _source2plainObject(pageTiming);

	                console.log('[v-collect] owl auto: ', pageTiming.firstScreen);
	                core.report("performance", "pageTiming_auto", plainData);
	            });
	        }
	    };

	    this.reportTime = function _reportTime(time, otherResult) {
	        var pageTiming = performance.timing;

	        pageTiming.name = "document";
	        pageTiming.entryType = "navigation";
	        pageTiming.startTime = 0;
	        pageTiming.duration = pageTiming.responseEnd - pageTiming.navigationStart;
	        _perfQueue._firstScreenLoadEnd = time;
	        _perfQueue._pageTiming = pageTiming;

	        _setResourceTiming();
	        // console.log('自动上报时刻：', Date.now() - scriptStartTime);
	        _perfQueue.reportData(otherResult);
	    };

	    function _source2plainObject(target) {
	        var copy = {};
	        for (var key in target) {
	            if (typeof target[key] == "function") continue;
	            if (typeof target[key] == "number") {
	                copy[key] = Number(target[key].toFixed(3));
	            } else {
	                copy[key] = target[key];
	            }
	        }
	        return copy;
	    }

	    function _setPageTiming () {
	        var pageTiming = performance.timing;

	        pageTiming.name = "document";
	        pageTiming.entryType = "navigation";
	        pageTiming.startTime = 0;
	        pageTiming.duration = pageTiming.responseEnd - pageTiming.navigationStart;

	        _perfQueue._firstScreenLoadEnd = Date.now();
	        _perfQueue._pageTiming = pageTiming;
	    }

	    function _setResourceTiming () {
	        if (typeof performance.getEntries === "function") {
	            var resource = performance.getEntriesByType("resource");
	            _perfQueue._resourceTiming = resource;
	        }
	    }

	    function _recordResourceType (resource) {
	        var initiatorType = resource.initiatorType;
	        this.resourceCounts++;
	        switch (initiatorType) {
	            case "link":
	                if (resource.name.search(/\.css$/) > -1) {
	                    this.cssCounts++;
	                }
	                break;
	            case "script":
	                this.jsCounts++;
	                break;
	            case "img":
	            case "css":
	                this.imgCounts++;
	                break;
	            case "xmlhttprequest":
	                this.xhrCounts++;
	                break;
	        }
	    }
	}

	perf.install = function (core) {
	    initUserTimingAPI.call(perf, core);
	    runPerf.call(perf, core);

	    autoFirstScreen({
	        xhr: {
	            limitedIn: [/weidian/i], // 只监听 weidian 域内的请求
	            exclude: [/web\.collect/i] // 屏蔽 vcollect 上报时发出的 XHR 请求
	        },
	        onTimeFound: function (result) {
	            perf.reportTime(result.finishedTime);
	        }
	    });
	};

	module.exports = perf;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @description auto compute first screen time of one page with inaccuracy less than 200ms
	 * @author 刘远洋 https://github.com/hoperyy
	 * @date 2018/02/22
	 */

	// 脚本开始运行的时间，用于各种 log 等
	var scriptStartTime = new Date().getTime();

	// 扩展 MutationObserver 的兼容性
	__webpack_require__(7);

	var win = window;
	var doc = win.document;

	var timeRunner = genTimeRunner();

	var MutationObserver = win.MutationObserver;

	// dom 变化监听器
	var mutationObserver = null;

	// 是否已经上报的标志
	var hasReported = false;

	// 是否抓取到过 XHR 请求的标志位
	var isFirstXhrSent = false;

	// 记录 Mutation 回调时的 dom 信息
	var domUpdatePool = [];

	// 可以抓取请求的时间窗口队列
	var catchXhrTimePool = [];

	// 记录图片加载完成的时刻（唯一）
	var imgDowloadTimePool = {};

	// 用于记录两次 mutationObserver 回调触发的时间间隔
	var lastDomUpdateTime;

	var xhrStatusPool = {};

	// 一些可配置项，下面是默认值
	var _options = {
	    onTimeFound: function (/* result */) {
	        // result.finishedTime: 首屏完成的时刻
	        // result.lastedTime: result.finishedTime - window.performance.timing.navigationStart 首屏持续的时间
	        // result.maxErrorTime: targetInfo.blankTime // 最大误差值
	    },
	    xhr: {
	        limitedIn: [],
	        exclude: [/(sockjs)|(socketjs)|(socket\.io)/]
	    },

	    // 从第一个 XHR 请求发出，到可以认为所有影响首屏的数据请求都已发出的时间段
	    firstScreenXhrLastedTime: 1000,

	    // 获取数据后，认为渲染 dom 的时长
	    renderTimeAfterGettingData: 300
	};

	function parseUrl(url) {
	    var anchor = document.createElement('a');
	    anchor.href = url;
	    return anchor;
	}

	function getMatchedTimeInfo(domUpdatePool) {
	    // 倒序
	    domUpdatePool.sort(function (a, b) {
	        if (a.time < b.time) {
	            return 1;
	        } else {
	            return -1;
	        }
	    });

	    // 获取当前时刻的 dom 信息，作为基准值
	    var finalImages = domUpdatePool[0].images;

	    var targetInfo;

	    var isBiggerArray = function (bigArr, smallArr, testIndex) {
	        for (var i = 0, len = smallArr.length; i < len; i++) {
	            if (bigArr.indexOf(smallArr[i]) === -1) {
	                return false;
	            }
	        }
	        return true;
	    };

	    if (finalImages.length > 0) {
	        for (var i = 1, len = domUpdatePool.length; i < len; i++) {
	            var item = domUpdatePool[i];

	            // 如果最终状态的首屏有图片，则通过比较首屏图片数量来确定是否首屏加载完毕；否则直接使用最后一次渲染时的 dom（默认）
	            if (!isBiggerArray(item.images, finalImages, i)) {
	                break;
	            }
	        }

	        i--;

	        // i === 0 说明没有匹配的
	        targetInfo = domUpdatePool[i];
	    } else {
	        for (var i = 1, len = domUpdatePool.length; i < len; i++) {
	            var item = domUpdatePool[i];

	            // 如果稳定状态没有图片，选取最近一次 dom 变化的时刻为最终时刻
	            if (!item.isFromInternal) {
	                break;
	            }
	        }

	        targetInfo = domUpdatePool[i];
	    }

	    return targetInfo;
	}

	// 插入脚本，用于获取脚本运行完成时间，这个时间用于获取当前页面是否有异步请求发出
	function insertTestTimeScript() {
	    var insertedScript = null;
	    var SCRIPT_FINISHED_FUNCTION_NAME = 'FIRST_SCREEN_SCRIPT_FINISHED_TIME_' + scriptStartTime;

	    window[SCRIPT_FINISHED_FUNCTION_NAME] = function () {
	        // 如果脚本运行完毕，页面还没有 XHR 请求，则尝试上报
	        if (!isFirstXhrSent) {
	            handlerAfterStableTimeFound();
	        }

	        // 清理
	        document.body.removeChild(insertedScript);
	        insertedScript = null;
	        window[SCRIPT_FINISHED_FUNCTION_NAME] = null;
	    };

	    document.addEventListener('DOMContentLoaded', function (event) {
	        insertedScript = document.createElement('script');
	        insertedScript.innerHTML = 'window.' + SCRIPT_FINISHED_FUNCTION_NAME + ' && window.' + SCRIPT_FINISHED_FUNCTION_NAME + '()';
	        insertedScript.async = false;
	        document.body.appendChild(insertedScript);
	    });
	}

	function getLastImgDownloadTime(images) {
	    var timeArr = [];

	    images.forEach(function (src) {
	        timeArr.push(imgDowloadTimePool[src]);
	    });

	    // 倒序
	    timeArr.sort(function (a, b) {
	        if (a < b) {
	            return 1;
	        } else {
	            return -1;
	        }
	    });

	    return timeArr[0];
	}

	function recordDomInfo(param) {
	    // 记录当前时刻的 DOM 信息
	    var nowTime = new Date().getTime();
	    var images = getImagesInFirstScreen();
	    // var images = getImagesInFullPage();
	    var obj = {
	        isFromInternal: (param && param.isInterval) ? true : false,
	        isTargetTime: false,
	        images: images,
	        blankTime: new Date().getTime() - lastDomUpdateTime || new Date().getTime(), // 距离上次记录有多久（用于调试）
	        finishedTime: -1, // 当前时刻下，所有图片加载完毕的时刻
	        time: nowTime // 当前时刻
	    };

	    var imgIndex = 0;
	    var afterDownload = function (src) {
	        imgIndex++;

	        if (imgIndex === images.length) {
	            // 获取所有图片中加载时间最迟的时刻，作为 finishedTime
	            obj.finishedTime = getLastImgDownloadTime(images);

	            // 如果图片加载完成时，发现该时刻就是目标时刻，则执行上报
	            if (obj.isTargetTime) {
	                // 回调
	                _options.onTimeFound({
	                    lastedTime: obj.finishedTime - window.performance.timing.navigationStart,
	                    finishedTime: obj.finishedTime,
	                    maxErrorTime: obj.blankTime, // 最大误差值

	                    xhrList: xhrStatusPool,
	                    domUpdatePool: domUpdatePool
	                });
	            }
	        }
	    };

	    images.forEach(function (src) {
	        if (imgDowloadTimePool[src]) {
	            afterDownload(src);
	        } else {
	            var img = new Image();
	            img.src = src;

	            if (img.complete) {
	                // 记录该图片加载完成的时间，以最早那次为准
	                if (!imgDowloadTimePool[src]) {
	                    imgDowloadTimePool[src] = new Date().getTime();
	                }
	                afterDownload(src);
	            } else {
	                img.onload = img.onerror = function () {
	                    // 记录该图片加载完成的时间，以最早那次为准
	                    if (!imgDowloadTimePool[src]) {
	                        imgDowloadTimePool[src] = new Date().getTime();
	                    }
	                    afterDownload(src);
	                };
	            }
	        }
	    });

	    // 如果没有图片，则以当前 DOM change 的时间为准
	    if (images.length === 0) {
	        obj.finishedTime = nowTime;
	    }

	    domUpdatePool.push(obj);

	    lastDomUpdateTime = new Date().getTime();
	}

	function genTimeRunner() {
	    var timer = null;
	    var shouldBreak = false;

	    function clearInterval() {
	        clearTimeout(timer);
	        shouldBreak = true;
	    }

	    function setInterval(callback, delay) {
	        shouldBreak = false;
	        var startTime = new Date().getTime();
	        var count = 0;
	        var handler = function () {
	            clearTimeout(timer);

	            count++;
	            var offset = new Date().getTime() - (startTime + count * delay);
	            var nextTime = delay - offset;
	            if (nextTime < 0) {
	                nextTime = 0;
	            }

	            callback();

	            if (shouldBreak) {
	                return;
	            }

	            timer = setTimeout(handler, nextTime);
	        };
	        timer = setTimeout(handler, delay);

	        return timer;
	    }

	    return {
	        setInterval: setInterval,
	        clearInterval: clearInterval
	    };
	}

	function observeDomChange() {
	    // 虽然定时器的间隔设置为200，但实际运行来看，间隔的时机仍然有较大误差
	    var mutationIntervalDelay = 200;

	    // 一次轮询任务持续的最长时间
	    var maxQueryTime = 3000;

	    // var timeDot = new Date().getTime();

	    var mutationIntervalStartTime = new Date().getTime();

	    var mutationIntervalCallback = function () {
	        recordDomInfo({ isInterval: true });
	    };

	    // 记录首屏 DOM 的变化
	    mutationObserver = new MutationObserver(function () {
	        recordDomInfo();

	        mutationIntervalCount = 0;
	        timeRunner.clearInterval();

	        // 每次浏览器检测到的 dom 变化后，启动轮询定时器，但轮询次数有上限
	        mutationIntervalStartTime = new Date().getTime();
	        timeRunner.setInterval(mutationIntervalCallback, mutationIntervalDelay);
	    });
	    mutationObserver.observe(document.body, {
	        childList: true,
	        subtree: true
	    });

	    // 触发回调前，先记录初始时刻的 dom 信息
	    recordDomInfo();
	}

	function _queryImages(isMatch, success) {
	    var screenHeight = win.innerHeight;

	    var nodeIterator = doc.createNodeIterator(
	        doc.body,
	        NodeFilter.SHOW_ELEMENT,
	        function (node) {
	            if (node.nodeName.toUpperCase() == 'IMG') {
	                return NodeFilter.FILTER_ACCEPT;
	            } else if (win.getComputedStyle(node).getPropertyValue('background-image') !== 'none') { // win.getComputedStyle 会引起重绘
	                return NodeFilter.FILTER_ACCEPT;
	            }
	        }
	    );

	    var currentNode = nodeIterator.nextNode();
	    var imgList = [];
	    while (currentNode) {
	        if (!isMatch(currentNode)) {
	            currentNode = nodeIterator.nextNode();
	            continue;
	        }

	        var src = '';
	        if (currentNode.nodeName.toUpperCase() == 'IMG') {
	            src = currentNode.getAttribute('src');
	        } else {
	            var bgImg = win.getComputedStyle(currentNode).getPropertyValue('background-image'); // win.getComputedStyle 会引起重绘
	            var match = bgImg.match(/^url\(['"](.+\/\/.+)['"]\)$/);
	            src = match && match[1];
	        }

	        var protocol = parseUrl(src).protocol;
	        if (src && protocol && protocol.indexOf('http') === 0) {
	            success(src);
	        }

	        currentNode = nodeIterator.nextNode();
	    }
	}

	function getImagesInFirstScreen() {
	    var screenHeight = win.innerHeight;

	    var imgList = [];

	    _queryImages(function (currentNode) {
	        // 过滤函数，如果符合要求，返回 true

	        var boundingClientRect = currentNode.getBoundingClientRect();

	        // 如果已不显示
	        if (!boundingClientRect.top && !boundingClientRect.bottom) {
	            return false;
	        }

	        var topToView = boundingClientRect.top; // getBoundingClientRect 会引起重绘
	        var scrollTop = doc.body.scrollTop;

	        // 如果在首屏
	        if ((scrollTop + topToView) <= screenHeight) {
	            return true;
	        }
	    }, function (src) {
	        // 去重
	        if (imgList.indexOf(src) === -1) {
	            imgList.push(src);
	        }
	    });

	    return imgList;
	}

	function getImagesInFullPage() {
	    var imgList = [];

	    _queryImages(function () { }, function (src) {
	        if (imgList.indexOf(src) === -1) {
	            imgList.push(src);
	        }
	    });

	    return imgList;
	}

	function handlerAfterStableTimeFound() {
	    if (hasReported) {
	        return;
	    }

	    hasReported = true;
	    mutationObserver.disconnect();
	    timeRunner.clearInterval();

	    // 记录当前时刻
	    recordDomInfo();

	    // 找到离稳定状态最近的渲染变动时刻
	    var targetInfo = getMatchedTimeInfo(domUpdatePool);

	    if (!targetInfo) {
	        console.log('没有找到合适的上报点，不再上报');
	        return;
	    }

	    // 标记该变动时刻为目标时刻
	    targetInfo.isTargetTime = true;

	    // 如果 target 时刻的图片已经加载完毕，则上报该信息中记录的完成时刻
	    if (targetInfo.finishedTime !== -1) {
	        _options.onTimeFound({
	            lastedTime: targetInfo.finishedTime - window.performance.timing.navigationStart,
	            finishedTime: targetInfo.finishedTime,
	            maxErrorTime: targetInfo.blankTime, // 最大误差值

	            xhrList: xhrStatusPool,
	            domUpdatePool: domUpdatePool
	        });
	    }
	}

	function overrideXhr() {
	    var xhrTimerStatusPool = {};

	    var XhrProto = XMLHttpRequest.prototype;
	    XhrProto.testFirstScreenSend = XhrProto.send;

	    var isXhrStatusPoolEmpty = function () {
	        for (var key in xhrStatusPool) {
	            if (key.indexOf('request-') !== -1 && xhrStatusPool[key] !== 'complete') {
	                return false;
	            }
	        }

	        return true;
	    };

	    var isXhrTimerPoolEmpty = function () {
	        for (var key in xhrTimerStatusPool) {
	            if (key.indexOf('request-') !== -1 && xhrTimerStatusPool[key] !== 'stopped') {
	                return false;
	            }
	        }

	        return true;
	    };

	    // 标志是否在获取 XHR 请求的时间区间内
	    var isCatchXhrTimeout = false;
	    // 如果是第一次抓取到 XHR 请求，则开始定时器，持续时间 FIRST_SCREEN_XHR_LASTED_TIME，获取在此期间内的所有 XHR 请求
	    var setupCatchingXhrTimer = function () {
	        var timer = setTimeout(function () {
	            isCatchXhrTimeout = true;

	            // 如果时间已到，并且请求池内没有未返回的请求了，说明窗口期内的请求均已返回完毕，该时刻为首屏稳定状态，执行相关函数
	            if (isXhrStatusPoolEmpty() && isXhrTimerPoolEmpty()) {
	                handlerAfterStableTimeFound();
	            }

	            clearTimeout(timer);
	        }, _options.firstScreenXhrLastedTime);
	    };

	    var catchThisXhr = function () {
	        var sendTime = new Date().getTime();
	        var poolName = 'request-' + this._http.url + '-' + sendTime;
	        xhrStatusPool[poolName] = 'sent';
	        xhrTimerStatusPool[poolName] = 'start';

	        var oldReadyCallback = this.onreadystatechange;
	        this.onreadystatechange = function () {
	            if (this.readyState === 4) {
	                // 标记这个请求完成
	                xhrStatusPool[poolName] = 'complete';

	                //  当前时刻
	                var returnTime = new Date().getTime();
	                // 从这个请求返回的时刻起，在较短的时间段内的请求也需要被监听
	                catchXhrTimePool.push([returnTime, returnTime + _options.renderTimeAfterGettingData]);

	                var timer = setTimeout(function () {
	                    xhrTimerStatusPool[poolName] = 'stopped';
	                    if (isCatchXhrTimeout && isXhrStatusPoolEmpty() && isXhrTimerPoolEmpty()) {
	                        handlerAfterStableTimeFound();
	                    }
	                    clearTimeout(timer);
	                }, _options.renderTimeAfterGettingData);
	            }

	            if (oldReadyCallback && oldReadyCallback.apply) {
	                oldReadyCallback.apply(this, arguments);
	            }
	        };
	    };

	    var shouldCatchThisXhr = function (url) {
	        // 默认抓取该请求到队列，认为其可能影响首屏
	        var shouldCatch = true;

	        // 如果已经上报，则不再抓取请求
	        if (hasReported) {
	            shouldCatch = false;
	        }

	        var sendTime = new Date().getTime();

	        // 如果发送数据请求的时间点超过了抓取数据的时间窗口，并且不在其他时间窗口内，则认为不该抓取该请求到队列
	        if (isCatchXhrTimeout) {
	            for (var sectionIndex = 0; sectionIndex < catchXhrTimePool.length; sectionIndex++) {
	                var poolItem = catchXhrTimePool[sectionIndex];
	                if (sendTime >= poolItem[0] && sendTime <= poolItem[1]) {
	                    break;
	                }
	            }
	            if (sectionIndex === catchXhrTimePool.length) {
	                shouldCatch = false;
	            }
	        }

	        // 如果发送请求地址不符合白名单和黑名单规则。则认为不该抓取该请求到队列
	        for (var i = 0, len = _options.xhr.limitedIn.length; i < len; i++) {
	            if (!_options.xhr.limitedIn[i].test(url)) {
	                shouldCatch = false;
	            }
	        }

	        for (var i = 0, len = _options.xhr.exclude.length; i < len; i++) {
	            if (_options.xhr.exclude[i].test(url)) {
	                shouldCatch = false;
	            }
	        }

	        return shouldCatch;
	    }

	    XhrProto.send = function () {
	        if (shouldCatchThisXhr(this._http.url)) {
	            if (!isFirstXhrSent) {
	                isFirstXhrSent = true;
	                setupCatchingXhrTimer.apply(this, arguments);
	            }

	            catchThisXhr.apply(this, arguments);
	        }

	        return XhrProto.testFirstScreenSend.apply(this, [].slice.call(arguments));
	    };
	}

	function mergeUserOptions(userOptions) {
	    if (userOptions) {
	        if (userOptions.onTimeFound) {
	            _options.onTimeFound = function () {
	                userOptions.onTimeFound.apply(this, arguments);
	            };
	        }

	        if (userOptions.xhr) {
	            if (userOptions.xhr.limitedIn) {
	                _options.xhr.limitedIn = _options.xhr.limitedIn.concat(userOptions.xhr.limitedIn);
	            }
	            if (userOptions.xhr.exclude) {
	                _options.xhr.exclude = _options.xhr.exclude.concat(userOptions.xhr.exclude);
	            }
	        }

	        if (userOptions.firstScreenXhrLastedTime) {
	            _options.firstScreenXhrLastedTime = userOptions.firstScreenXhrLastedTime;
	        }

	        if (userOptions.renderTimeAfterGettingData) {
	            _options.renderTimeAfterGettingData = userOptions.renderTimeAfterGettingData;
	        }
	    }
	}

	module.exports = function (userOptions) {
	    mergeUserOptions(userOptions);
	    insertTestTimeScript();
	    observeDomChange();
	    overrideXhr();
	};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	/**
	 * 如果业务方在调用上存在错误，spider通过两种方式进行通知
	 * 在必经流程中，使用 throw new Error() 抛出异常  ==> 修正为 console.warn by liuyuanyang 2018/01/27；
	 * 在边界场景中，使用 console API 与 return 特殊值的方式取消本次行为与给予提示
	 */

	var util = __webpack_require__(2);
	var tryjs = __webpack_require__(8);
	var spiderImpression = __webpack_require__(14);

	var sha1 = util._sha1;
	var console = util._console;
	var spider = {};
	var VERSION = "0.0.24";

	var DATA_SPIDER = "data-spider";
	var DATA_SPIDER_PRIOR = "data-spider-prior";
	var DATA_SPIDER_MODE = "data-spider-mode";
	var DATA_ACTION_NAME = "data-spider-action-name";
	var DATA_ACTION_ARGS = "data-spider-action-args";
	var DATA_SPIDER_IMPRESSION = "data-spider-impression";

	var URL_SEARCH_PARAMS_SPM = "spider";
	var URL_SEARCH_PARAMS_KEY = "spider_token";

	var COOKIE_NAME_PREFIX = "__spider__" + "token" + "_";
	var cookieStoreDomain = util._getCookieStoreDomain();

	var bodyObserve = __webpack_require__(6);

	var constants = {
	    "BUY_NOW": "_buyNow",
	    "ADD_TO_CART": "_addToCart",
	    "ADD_TO_FAVORITES": "_addToFavorites",
	    "SHARE": "_share",
	    "LIKE": "_like",
	    "EXPOSE": "_expose",
	    "ITEM": "_item",
	    "SHOP": "_shop",
	    "DEPRECATED": "_deprecated"
	};

	// default value should always be compliant
	var cur_spm_array = [undefined, undefined, undefined, undefined];
	var cur_page_args = {};
	var cur_action_name = "";
	var cur_action_args = {};
	var cur_elem = null;

	// var prevSpmb = "";

	cur_spm_array.toString = function () {
	    return this.join(".");
	};

	function reset() {
	    spider.trackPageview = util._noop;
	    spider.trackAction = util._noop;
	    spider.transferAction = util._noop;
	    spider.transferActionBy = util._noop;
	    spider.getClickElement = util._noop;
	    spider.extractActionFrom = util._noop;

	    spider.disableAutoReport = util._noop;
	    spider.constants = util._noop;

	    spider.getSearchParams = util._noop;
	    spider.getCookie = util._getCookie;
	    spider.VERSION = VERSION;
	}

	// 恢复出厂设置（该逻辑不会报错，用于 catch 到错误后的恢复）
	spider.reset = reset;

	spider.init = function(core) {
	    // 先初始化
	    this.reset();

	    var storeKey = _getCurURLSearchParams()[URL_SEARCH_PARAMS_KEY];

	    function trackPageview(pageArgs) {
	        var args = arguments;

	        // 参数可变，进行适配
	        if (args.length === 0) {
	            pageArgs = {};
	        } else {
	            pageArgs = typeof args[args.length - 1] === 'object' ? args[args.length - 1] : {};
	        }

	        // pageArgs = pageArgs || {};
	        var meta = core.getMeta();

	        cur_spm_array[0] = meta.spma;
	        cur_spm_array[1] = meta.spmb;
	        cur_spm_array[2] = "0";
	        cur_spm_array[3] = "0";

	        // 如果两次执行函数时 spmb 值都相同
	        // if (prevSpmb && prevSpmb === meta.spmb) {
	        //     return;
	        // }

	        var prevInfo = _restorePrevInfo();
	        // make to a function, todo
	        if (pageArgs._page) {
	            var actionName = pageArgs._page;
	            delete pageArgs._page;
	            if (_isBuildinActionName(actionName)) {
	                // 这个判断条件很重要，非常重要，要提取成函数
	                if (prevInfo.prev_spm) {
	                    prevInfo.prev_action_name = actionName;
	                    prevInfo.prev_action_args = util._extendObj({}, pageArgs, prevInfo.prev_action_args);
	                }
	            } else {
	                console.error("pageArgs._page 需是内置的 actionName 值，详见 spider.contants");
	            }
	        }
	        // if prevAction still don't have actionName, default to one
	        if (!prevInfo.prev_action_name && prevInfo.prev_spm) {
	            prevInfo.prev_action_name = "_jumpTo_" + cur_spm_array[0] + "." + cur_spm_array[1];
	        }

	        _sendPrevActionIfNeeded(prevInfo);

	        cur_page_args = pageArgs;
	        // always ignore developer-defined ts & wfr
	        cur_page_args.ts = +new Date();
	        cur_page_args.wfr = _getCurURLSearchParams()["wfr"];
	        if (!cur_page_args.wfr) {
	            delete cur_page_args.wfr;
	        }
	        cur_page_args.ifr = _getCurURLSearchParams()["ifr"];
	        if (!cur_page_args.ifr) {
	            delete cur_page_args.ifr;
	        }

	        // make to a function like _constructPageviewReportData, todo
	        var curInfo = util._extendObj({}, prevInfo);
	        curInfo.cur_spm = cur_spm_array.toString();
	        curInfo.cur_page_args = cur_page_args;

	        if (!cur_spm_array[0] || !cur_spm_array[1]) {
	            // 如果 a、b 位有一个不存在，则不上报
	            // console.warn("[vcollect 提示] meta & body 上必须包含 data-spider 值");
	            return;
	        }
	        // console.log('spider report', curInfo);        
	        _report("page_view", curInfo);

	        // prevSpmb = meta.spmb;
	    }

	    function trackAction(action, callback) {
	        var success = _updateState(action);
	        if (!success) return;
	        _report("click", _constructActionReportData(), callback);
	    }

	    function trackImpression(action, callback) {
	        var success = _updateState(action);
	        if (!success) return;
	        _report("expose", _constructActionReportData(), callback);
	    }

	    function transferActionBy(url, action) {
	        if (!_isHttpOrHttpsUrl(url)) {
	            return url;
	        }

	        if (_is3rdPartUrl(url)) {
	            trackAction(action);
	            return url;
	        }

	        var success = _updateState(action);
	        if (!success) return url;

	        var parsedUrl = util._urlParse(url);
	        var query = util._queryStringParse(parsedUrl.search.replace("?", ""));

	        query[URL_SEARCH_PARAMS_KEY] = _storeCurInfoToCookie();
	        // keep here to be compatibility with piwik-spm.js
	        query[URL_SEARCH_PARAMS_SPM] = cur_spm_array.toString();

	        var curUrlParams = _getCurURLSearchParams();
	        query.wfr = query.wfr || curUrlParams.wfr;
	        query.ifr = query.ifr || curUrlParams.ifr;

	        if (!query.wfr) delete query.wfr;
	        if (!query.ifr) delete query.ifr;

	        var hash = parsedUrl.hash;
	        var querystring = util._queryStringStringify(query);

	        // use string replace instead of using URLUtils.toString()
	        // to preserve the original string as far as possible
	        return url.replace(/(\?|#)[\S]*$/, "") + "?" + querystring + hash;
	    }

	    function transferAction(action) {
	        var success = _updateState(action);
	        if (!success) {
	            return;
	        } else {
	            core.updateDocReferrer();
	            storeKey = _storeCurInfoToCookie();
	        }
	    }

	    function getClickElement() {
	        return cur_elem;
	    }

	    /**
	     * extractActionFrom, if the input is a valid SpiderElement return action
	     * else return null.  can also be used as isSpiderElement() function
	     *
	     * @param   {HTMLElement}   spiderElement
	     * @returns {Action|null}   not completely validated, just from DOM
	     */
	    function extractActionFrom(spiderElement) {
	        if (!(_isElement(spiderElement) && _isSpiderElementLikely(spiderElement))) {
	            console.error("extractActionFrom() 应接收 spiderElement 作参数");
	            return null;
	        }

	        var dElem = spiderElement;
	        var actionName = dElem.getAttribute(DATA_ACTION_NAME) || "";

	        var actionArgs = util._JSONParseSafty(dElem.getAttribute(DATA_ACTION_ARGS));

	        var cElem = _closestElementUntilBody(dElem.parentNode, _isSpiderCElement);

	        var spmc;
	        var spmd;
	        if (cElem) {
	            spmc = cElem.getAttribute(DATA_SPIDER_PRIOR) || cElem.getAttribute(DATA_SPIDER);
	            spmd = String(_getIndexOf_From(dElem, cElem) || "_");
	        } else {
	            spmc = "_";
	            spmd = String(_getIndexOfFreeBtn(dElem) || "_");
	        }

	        return {
	            spmc: spmc,
	            spmd: spmd,
	            actionName: actionName,
	            actionArgs: actionArgs
	        };
	    }

	    // to fix webkit highlight color, use document.body
	    document.body.addEventListener("click", _eventHandler, true);
	    function disableAutoReport() {
	        document.body.removeEventListener("click", _eventHandler, true);
	        return _eventHandler;
	    }

	    function _constructActionReportData() {
	        return {
	            cur_spm: cur_spm_array.toString(),
	            cur_page_args: cur_page_args,
	            cur_action_name: cur_action_name,
	            cur_action_args: cur_action_args,
	        };
	    }

	    function _constructPageviewReportData(prevInfo) {
	        // todo init

	        var transformed = _replacePropertyPrefix(prevInfo, "cur_", "prev_");

	        return util._extendObj({}, transformed, {
	            cur_spm: cur_spm_array.toString(),
	            cur_page_args: cur_page_args,
	        });
	    }

	    function _closestElementUntilBody(startElement, matcher) {
	        var target = startElement;
	        while (true) {
	            if (target === document.body) return null;
	            if (target === document.documentElement) return null;
	            // elem.parentNode may return null @see http://devdocs.io/dom/node/parentnode
	            if (target === null) return null;
	            if (matcher(target)) return target;

	            target = target.parentNode;
	        }
	    }

	    function _isSpiderElementLikely(elem) {
	        if (elem.hasAttribute(DATA_SPIDER) && elem.getAttribute(DATA_SPIDER) === "") return true;
	        if (elem.getAttribute(DATA_ACTION_NAME) || elem.getAttribute(DATA_SPIDER_IMPRESSION)) return true;
	        if (_isNetworkA(elem)) return true;

	        return false;
	    }

	    function _isSpiderCElement(elem) {
	        return !!(elem.getAttribute(DATA_SPIDER_PRIOR) || elem.getAttribute(DATA_SPIDER));
	    }

	    function _isElement(any) {
	        if (!util._isObjectAndNotNull(any)) return false;
	        return any.nodeType === Node.ELEMENT_NODE ? true : false;
	    }

	    /**
	     * get index of elem from spiderCElement's descendant spiderElement,
	     * index starts from 1
	     * number 0 is used to represent not finding elem in spiderCElement
	     *
	     * @param   {Element} elem
	     * @param   {Element} spiderCElement
	     * @returns {number}
	     */
	    function _getIndexOf_From(elem, spiderCElement) {
	        var MISSING_VALUE = 0;
	        var elements = _getPotentialSpiderElementFrom(spiderCElement);
	        var count = 0;

	        for (var i = 0, len = elements.length; i < len; i++) {
	            var element = elements[i];
	            if (_isSpiderElementLikely(element)) count++;
	            if (element === elem) {
	                return count;
	            }
	        }

	        return MISSING_VALUE;
	    }

	    function _getIndexOfFreeBtn(elem) {
	        var MISSING_VALUE = 0;
	        var count = 0;
	        var elements = document.querySelectorAll("[" + DATA_ACTION_NAME + "], [" + DATA_SPIDER_IMPRESSION + "]");

	        for (var i = 0; i < elements.length; i++) {
	            var cElem = _closestElementUntilBody(elements[i].parentNode, _isSpiderCElement);
	            if (cElem === null) count++;
	            if (elem === elements[i]) return count;
	        }

	        return MISSING_VALUE;
	    }

	    function _getPotentialSpiderElementFrom(contextElem) {
	        return contextElem.querySelectorAll("[" + DATA_SPIDER + "], [" + DATA_ACTION_NAME + "],[" + DATA_SPIDER_IMPRESSION + "], a[href]");
	    }

	    function _eventHandler(e) {
	        var dElem = _closestElementUntilBody(e.target, _isSpiderElementLikely);
	        if (dElem === null) return;

	        var action = extractActionFrom(dElem);
	        if (action === null) return;

	        // structurally unvalid action should not be treated as SpiderElement
	        // should make the assert here instead of in extractActionFrom
	        if (action.spmc === "_" && action.actionName === "") {
	            return;
	        }

	        var actionMode = dElem.getAttribute(DATA_SPIDER_MODE);
	        cur_elem = dElem;
	        switch (actionMode) {
	            case "none":
	                break;
	            case "transferAction":
	                transferAction(action);
	                break;
	            case "transferActionBy":
	                var url = dElem.getAttribute("data-href");
	                if (url) {
	                    dElem.setAttribute("data-href", transferActionBy(url, action));
	                }
	                break;
	            case "trackAction":
	                trackAction(action);
	                break;
	            // absent or invalid of DATA_SPIDER_MODE
	            default:
	                // if dElem itself OR it's ancestor element matches <a>[href]
	                // this will change the action mode to transferActionBy
	                // this is worthy noticing, and need to clarify
	                var aElem = _closestElementUntilBody(dElem, function (elem) {
	                    return _isNetworkA(elem);
	                });

	                if (aElem) {
	                    aElem.href = transferActionBy(aElem.href, action);
	                } else {
	                    trackAction(action);
	                }
	                break;
	        }
	    }

	    /**
	     *
	     * @param {Action|Element}  action
	     * @returns {boolean}   flag indicates whether it is success
	     */
	    function _updateState(action) {
	        if (_isElement(action)) {
	            action = extractActionFrom(action);
	            if (action === null) return false;
	        } else if (!util._isObjectAndNotNull(action)) {
	            console.error("action 必须是一个对象");
	            return false;
	        }

	        var spmc = String(action.spmc || "_");
	        var spmd = String(action.spmd || "_");

	        var actionName = String(action.actionName || "");
	        // deprecated
	        var actionType = String(action.actionType || "");
	        if (actionType) {
	            actionName = actionName || actionType;
	            console.warn("action.actionType 将废弃，请使用 action.actionName 代替");
	        }

	        if (action.actionArgs && typeof action.actionArgs !== "object") {
	            console.error("actionArgs 必须是一个 object");
	            return false;
	        }
	        var actionArgs = action.actionArgs || {};

	        if (!util._isValidSpmValue(spmc)) {
	            console.error("spm只允许英文、数字、中划线、下划线组成，" + spmc + "不合法");
	            return false;
	        }

	        if (!util._isValidSpmValue(spmd)) {
	            console.error("spm只允许英文、数字、中划线、下划线组成，" + spmd + "不合法");
	            return false;
	        }

	        if (actionName.indexOf("_") === 0 && !_isBuildinActionName(actionName)) {
	            console.error("下划线起始的 actionName 代表特定功能，禁止自定义，请查看 spider.constants 了解内置的 actionName");
	            return false;
	        }

	        if (spmc === "_" && actionName === "") {
	            console.error("spmc, actionName 不能同时为空");
	            return false;
	        }

	        if (spmc !== "_" && spmd === "_") {
	            console.error("spmc 有值时 spmd 不能同时为空");
	            return false;
	        }

	        cur_spm_array[2] = spmc;
	        cur_spm_array[3] = spmd;
	        cur_action_name = actionName;
	        cur_action_args = actionArgs;

	        return true;
	    }

	    // todo, info rename to action
	    function _storeCurInfoToCookie() {
	        var token = _generateToken(cur_spm_array.toString());
	        var cookieName = COOKIE_NAME_PREFIX + token;
	        var curInfo = _replacePropertyPrefix(_constructActionReportData(), "cur_", "prev_");
	        util._setCookie(cookieName, util._JSONStringifySafty(curInfo), {
	            domain: cookieStoreDomain,
	            path: "/",
	            "max-age": 30
	        });

	        return token;
	    }

	    function _generateToken(salt) {
	        salt = salt || "";
	        var now = new Date();

	        var key = sha1(
	            (navigator.userAgent || "") + now.getTime() + Math.random() + salt
	        ).slice(0, 4);

	        return key;
	    }

	    function _sendPrevActionIfNeeded(prevInfo) {
	        var spmMissingValue = "";
	        var curInfo = _replacePropertyPrefix(prevInfo, "prev_", "cur_");

	        if (curInfo["cur_spm"] === spmMissingValue) {
	            return;
	        } else {
	            _report("click", curInfo);
	        }
	    }

	    function _replacePropertyPrefix(obj, matchPrefix, replacePrefix) {
	        var ret = {};

	        Object.keys(obj).forEach(function (prevName) {
	            var curName = prevName.replace(matchPrefix, replacePrefix);
	            ret[curName] = obj[prevName];
	        });

	        return ret;
	    }

	    function _restorePrevInfo() {
	        var prevInfoDefault = _getDefaultPrevInfo();
	        if (storeKey) {
	            return _restorePrevInfoFromCookie(storeKey) || prevInfoDefault;
	        } else {
	            // keep here to be compatible with piwik-spm.js
	            return _restorePrevInfoFromURLSearchParams() || prevInfoDefault;
	        }
	    }

	    function _getDefaultPrevInfo() {
	        return {
	            prev_spm: "",
	            prev_page_args: {},
	            prev_action_name: "",
	            prev_action_args: {},
	        };
	    }

	    function _isBuildinActionName(str) {
	        return _isBuildinActionName.validList.indexOf(str) >= 0;
	    }
	    _isBuildinActionName.validList = Object.keys(constants).map(function (key) {
	        return constants[key];
	    });

	    function _getCurURLSearchParams() {
	        var search = (window.location.search || "?").replace("?", "");
	        return util._queryStringParse(search);
	    }

	    function _restorePrevInfoFromURLSearchParams() {
	        var spm = _getCurURLSearchParams()[URL_SEARCH_PARAMS_SPM];

	        if (!spm) {
	            return null;
	        } else {
	            var ret = _getDefaultPrevInfo();
	            ret.prev_spm = spm;
	            return ret;
	        }
	    }

	    function _restorePrevInfoFromCookie(key) {
	        var prevInfoStr = _getCookieAndClean(key);
	        if (prevInfoStr === null) return null;

	        return util._JSONParseSafty(prevInfoStr);
	    }

	    function _getCookieAndClean(key) {
	        var cookieName = COOKIE_NAME_PREFIX + key;
	        var val = util._getCookie(cookieName);

	        _delPollutedCookies();

	        return val;
	    }

	    function _delPollutedCookies() {
	        var cookies = util._getCookie();

	        Object.keys(cookies).forEach(function (cookieName) {
	            if (cookieName.indexOf(COOKIE_NAME_PREFIX) === 0) {
	                util._delCookie(cookieName, {
	                    domain: cookieStoreDomain,
	                    path: "/"
	                });
	            }
	        });
	    }

	    function _is3rdPartUrl(url) {
	        var parsedUrl = util._urlParse(url);
	        var linkHostname = parsedUrl.hostname;
	        var docHostname = location.hostname;

	        var get2ndDomain = function (str) {
	            return str.split(".").slice(-2).join(".");
	        };

	        return get2ndDomain(linkHostname) !== get2ndDomain(docHostname);
	    }

	    function _isNetworkA(elem) {
	        if (elem.nodeName === "A" && elem.protocol && elem.protocol.indexOf("http") === 0) {
	            return true;
	        } else {
	            return false;
	        }
	    }
	    function _isHttpOrHttpsUrl(url) {
	        var anchorElem = util._urlParse(url);
	        return _isNetworkA(anchorElem);
	    }

	    function _normalizeReportData(data) {
	        Object.keys(data).forEach(function (key) {
	            if (data[key] === "") {
	                data[key] = null;
	                return;
	            }

	            if (util._isObjectAndNotNull(data[key])) {
	                if (util._isEmptyObject(data[key])) {
	                    data[key] = null;
	                } else {
	                    // notice, todo
	                    Object.keys(data[key]).forEach(function (secondKey) {
	                        var value = data[key][secondKey];
	                        if (value === "" || typeof value === "object") {
	                            data[key][secondKey] = null;
	                        }
	                    });
	                }
	            }
	        });

	        return data;
	    }

	    function _report(subtype, data, callback) {
	        core.report("spider", subtype, _normalizeReportData(data), callback);
	    }

	    (function fixIOSClickBug() {
	        if (!navigator.userAgent.match(/iPhone OS [\d_]+/)) {
	            return;
	        }

	        var style = document.createElement("style");
	        style.type = "text/css";
	        style.innerHTML = "\
	    [data-spider=\"\"], \
	    [data-spider-action-type], \
	    [data-spider-action-name] {\
	        cursor: pointer; \
	    }";
	        document.getElementsByTagName("head").item(0).appendChild(style);
	    })();

	    (function autoTrackPageview() {
	        function autoTrack() {
	            cur_spm_array[2] = "0";
	            cur_spm_array[3] = "0";
	            // only modify pageview time and keep other status
	            cur_page_args.ts = +new Date();

	            var curInfo = _getDefaultPrevInfo();
	            curInfo.cur_spm = cur_spm_array.toString();
	            curInfo.cur_page_args = cur_page_args;

	            _report("page_view", curInfo);
	        }

	        window.addEventListener("pageshow", function (event) {
	            if (event.persisted === true) {
	                autoTrack();
	            }
	        });

	        // must figure out when this event get called,
	        // and notice the relationship with load and pageshow
	        // window.addEventListener("visibilitychange", function() {
	        //     if (document.visibilityState === "visible") {
	        //         autoTrack();
	        //     }
	        // });
	    })();

	    // 检查 API 是否过时
	    (function deprecateApi() {
	        function _obsolete(oldName, newName) {
	            console.warn("%s is deprecated, please use %s instead", oldName, newName);
	            trackAction({
	                actionName: constants.DEPRECATED
	            });
	        }

	        var ApiMap = {
	            "pageview": "trackPageview",
	            "action": "trackAction",
	            "update": "transferAction",
	            "updateUrl": "transferActionBy",
	            "disableDomHook": "disableAutoReport",
	        };

	        for (var oldApi in ApiMap) {
	            var newApi = ApiMap[oldApi];
	            spider[oldApi] = function () {
	                _obsolete(oldApi, newApi);
	                return spider[newApi].apply(this, [].slice.call(arguments));
	            };
	        }
	    })();
	    
	    spider.trackPageview = trackPageview;
	    spider.trackAction = trackAction;
	    spider.trackImpression = trackImpression;
	    spider.transferAction = transferAction;
	    spider.transferActionBy = transferActionBy;
	    spider.getClickElement = getClickElement;
	    spider.extractActionFrom = extractActionFrom;

	    spider.disableAutoReport = disableAutoReport;
	    spider.constants = constants;

	    spider.getSearchParams = _getCurURLSearchParams;

	    // 空方法，用于兼容旧式写法 spider.impression.observe
	    spider.impression = {
	        observe: function () { }
	    };

	    var plugins = util._listCustomPlugin();
	    if (plugins.indexOf("impression") > -1) {
	        spiderImpression.init(spider);
	    }

	        // 为 Congo 准备
	    (function loadVisualScript() {
	        function _loadScript(url, callback) {
	            var script = document.createElement("script");
	            script.src = url;

	            document.head && document.head.appendChild(script);
	            script.onload = function () {
	                callback && callback();
	            };
	        }

	        function _rewriteTrackPageview() {
	            // var spider = spider;
	            var trackPageview = spider.trackPageview;

	            spider.trackPageview = function () {
	                trackPageview.apply(this, [].slice.call(arguments));
	                window.spider_visual.init(cur_spm_array.toString(), cur_page_args);
	            };

	            if (cur_spm_array[0] !== undefined) {
	                window.spider_visual.init(cur_spm_array.toString(), cur_page_args);
	            }
	        }

	        if (window !== window.top && window.name.indexOf("visual-window:") === 0) {
	            var reg = /^visual-window:([\S\s]+)$/;
	            var whiteList = [
	                "assets.geilicdn.com",
	                "assets.pre.geilicdn.com",
	                "assets.daily.geilicdn.com",
	                "h5.dev.weidian.com"
	            ];

	            var url = window.name.match(reg)[1];
	            var anchorElem = util._urlParse(url);

	            if (!_isNetworkA(anchorElem) || whiteList.indexOf(anchorElem.hostname) < 0) {
	                return;
	            }

	            _loadScript(url, function () {
	                _rewriteTrackPageview();
	            });
	        }
	    })();
	};
	module.exports = spider;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var spider = __webpack_require__(13);
	var spiderImpression = {};

	spiderImpression.init = function(spider) {
	    var win = window;
	    var doc = document;
	    var ATTR_IMPRESSION = "data-spider-impression";
	    var viewport = {
	        height: win.innerHeight,
	        scrollHandler: _debounce(_calAndReportImpression, 500),
	        resizeHandler: function() {
	            viewport.height = win.innerHeight;
	            viewport.scrollHandler();
	        }
	    };
	    var already_exec = spider && spider.impression && spider.impression.ALREADY_EXEC || false;

	    function observe() {
	        if (!already_exec) {
	            spider.impression.ALREADY_EXEC = true;
	            viewport.scrollHandler();
	            win.addEventListener("resize", viewport.resizeHandler);
	            win.addEventListener("scroll", viewport.scrollHandler);
	        }
	    }

	    function disconnect() {
	        if (already_exec) {
	            spider.impression.ALREADY_EXEC = false;
	            win.removeEventListener("resize", viewport.resizeHandler);
	            win.removeEventListener("scroll", viewport.scrollHandler);
	        }
	    }

	    function _calAndReportImpression() {
	        // in case of dom scripting, we should do the query every time instead of snapshot
	        // unless we use mutationObserver to react to dom change
	        var maybeImpressionElems1 = doc.querySelectorAll("[" + ATTR_IMPRESSION + "=\"\"]") || [];
	        var maybeImpressionElems2 = doc.querySelectorAll("[" + ATTR_IMPRESSION + "=\"true\"]") || [];
	        var maybeImpressionElems = [];
	        for (var i = 0, l1 = maybeImpressionElems1.length; i < l1; i++) {
	            maybeImpressionElems.push(maybeImpressionElems1[i]);
	        }
	        for (var k = 0, l2 = maybeImpressionElems2.length; k < l2; k++) {
	            maybeImpressionElems.push(maybeImpressionElems2[k]);
	        }
	        [].forEach.call(maybeImpressionElems, function (element) {
	            if (_isInViewport(element)) {
	                // element should impress the reader only once
	                _markElementImpressed(element);
	                _reportImpression(element);
	            }
	        });
	    }

	    function _markElementImpressed(element) {
	        element.dataset.spiderImpression = "impressed";
	    }

	    function _reportImpression(element) {
	        var impressiondReport = spider.extractActionFrom(element);
	        if (impressiondReport) {
	            if (!impressiondReport.actionArgs.hasOwnProperty("spoor")) {
	                // console.warn("如果是推荐业务，请在data-spider-action-args中添加曝光埋点所需的spoor值");
	            }
	            spider.trackImpression(impressiondReport);
	        }
	    }

	    // strictly we should use isVisible and isInViewport both
	    function _isInViewport(element) {
	        var elemRect = element.getBoundingClientRect();
	        var elemTop = elemRect.top;
	        var elemHeight = elemRect.bottom - elemRect.top;
	        var viewportHeight = viewport.height;

	        //元素超过可视区高度情况
	        if (elemHeight > viewportHeight) {
	            return (elemTop >= -elemHeight * 3 / 4) && (elemTop <= viewportHeight * 3 / 4);
	        } else {
	            return (elemTop >= -elemHeight / 4 && elemTop <= viewportHeight - elemHeight * 3 / 4);
	        }
	    }

	    function _debounce(cb, delay) {
	        var timer;
	        return function () {
	            if (timer) clearTimeout(timer);
	            timer = setTimeout(function () {
	                cb && cb();
	            }, delay);
	        };
	    }

	    spider.impression = {
	        observe: observe,
	        disconnect: disconnect
	    };

	    observe();
	};

	module.exports = spiderImpression;
	    


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	var util = __webpack_require__(2);
	var sha1 = util._sha1;
	var canvasFp = __webpack_require__(5);
	var HttpUrl = __webpack_require__(16);
	var Share = __webpack_require__(17);
	__webpack_require__(18);
	var console = util._console;

	var tracker = {};
	var VERSION = "1.0.9";

	/*关系透传参数key & value：
	* key: share_relation
	* value:${分享唯一ID}_${分享来源WD_b_id}_${分享level}
	* */
	var TRAKC_QUERY_NAME = "share_relation";
	var TRACK_TYPE = "pathtracker";
	var TRACK_SUB_TYPE = {
	    click: "share_click",
	    first: "share_first",
	    reshare: "share_reshare"
	};
	tracker.version = VERSION;
	tracker.share = util._noop;
	tracker.getShareUrl = util._noop;
	tracker.successTrack = util._noop;

	tracker.init = function(core) {

	    var isDebug = location.search.indexOf("share_debug") != -1;

	    function _isEmptyObject(obj) {
	        console.assert(typeof obj === "object", "必须是一个object");
	        if (obj === null) return false;
	        if (Object.keys(obj).length === 0) {
	            return true;
	        } else {
	            return false;
	        }
	    }

	    function _isObjectAndNotNull(obj) {
	        if (typeof obj !== "object") return false;
	        if (obj === null) return false;
	        return true;
	    }

	    function _normalizeReportData(data) {
	        Object.keys(data).forEach(function (key) {
	            if (data[key] === "") {
	                data[key] = null;
	                return;
	            }

	            if (_isObjectAndNotNull(data[key])) {
	                if (_isEmptyObject(data[key])) {
	                    data[key] = null;
	                } else {
	                // notice, todo
	                    Object.keys(data[key]).forEach(function (secondKey) {
	                        var value = data[key][secondKey];
	                        if (value === "" || typeof value === "object") {
	                            data[key][secondKey] = null;
	                        }
	                    });
	                }
	            }
	        });

	        return data;
	    }

	    function _getMetaFromDom() {
	        var head = document.head;
	        var spma = head.querySelector("meta[name='data-spider']") && head.querySelector("meta[name='data-spider']").getAttribute("content");
	        var spmaPrior = head.querySelector("meta[name='data-spider-prior']") && head.querySelector("meta[name='data-spider-prior']").getAttribute("content");
	        var bizVersion = head.querySelector("meta[name='spider-biz-version']") && head.querySelector("meta[name='spider-biz-version']").getAttribute("content");
	        var spmb = document.body.getAttribute("data-spider-prior") || document.body.getAttribute("data-spider");

	        spma = spmaPrior || spma;

	        return {
	            spma: spma,
	            spmb: spmb,
	            bizVersion: bizVersion
	        };
	    }

	    function _report(subtype, data, callback) {
	        core.report(TRACK_TYPE, subtype, _normalizeReportData(data), callback);
	    }

	    function _getSearchParams(key) {
	        var search = (window.location.search || "?").replace("?", "");
	        return key ? (util._queryStringParse(search)[key] || null) : util._queryStringParse(search);
	    }

	    function _getPathInfo(path) {
	        var arr = path.split("_");
	        return {
	            share_id: arr[0] || "",
	            share_buyer_id: arr[1] || "",
	            share_level: arr[2] || ""
	        };
	    }

	    //生成分享唯一id
	    function _getShareId() {
	        try {
	            var salt = canvasFp();
	            var now = new Date();
	            var shareId = sha1(
	            (navigator.userAgent || "") + now.getTime() + Math.random() + salt
	        ).slice(0, 16);

	            return shareId;
	        } catch (e) {
	            return "";
	        }
	    }

	    //获取分享渠道
	    function _getChannel() {
	        var wfr = _getSearchParams("wfr");
	        if (!wfr) {
	            return "unknown";
	        }
	        var result = wfr;

	        //适配北京分享渠道
	        switch (result) {
	            case "wx":
	                result = "wxShare";
	                break;
	            case "wxp":
	                result = "wxGroupShare";
	                break;
	            case "qfriend":
	                result = "qqShare";
	                break;
	            case "wb":
	                result = "weiboShare";
	                break;
	            case "qzone":
	                result = "qzoneShare";
	                break;
	        }

	        return result;
	    }

	    //生成当前用户分享的链接
	    var share_id_first = "";
	    function _getShareUrl(url) {
	        try {
	            if (!url) {
	                return "";
	            }

	            var pathQuery = _getSearchParams(TRAKC_QUERY_NAME);
	            var value = "";
	            var share_buyer_id = util._getCookie("WD_b_id") || "";
	            var share_id = "";
	            var share_level = "";
	            if (pathQuery) {
	                //再次分享
	                var pathInfo = _getPathInfo(pathQuery);
	                share_id = pathInfo.share_id;
	                share_level = parseInt(pathInfo.share_level || 0) + 1;
	            } else {
	                //首次分享
	                share_id = _getShareId();
	                share_id_first = share_id;
	                share_level = 1;
	            }
	            value = [share_id, share_buyer_id, share_level].join("_");
	            var httpurl = new HttpUrl(url);
	            httpurl.params[TRAKC_QUERY_NAME] = value;
	            return httpurl.toString();
	        } catch (e) {
	            return url;
	        }
	    }

	    //基于不同的类型获取上报的数据信息
	    function _getTrackOption(type) {
	        try {
	            var pathQuery = _getSearchParams(TRAKC_QUERY_NAME);
	            var metaInfo = _getMetaFromDom();
	            var pathInfo = pathQuery ? _getPathInfo(pathQuery) : null;
	            var page_id = "";
	            if (metaInfo.spma && metaInfo.spmb) {
	                page_id = metaInfo.spma + "." + metaInfo.spmb;
	            }

	            if (type == TRACK_SUB_TYPE.click) {
	                //click数据类型
	                if (!pathQuery) {
	                    return {};
	                } else {
	                    return {
	                        share_id: pathInfo.share_id,
	                        page_id: page_id,
	                        share_buyer_id: pathInfo.share_buyer_id,
	                        share_channel: _getChannel(),
	                        share_level: parseInt(pathInfo.share_level),
	                        click_buyer_id: util._getCookie("WD_b_id") || "",
	                        click_seller_id: util._getCookie("WD_s_id") || "",
	                        gmt_action: Date.now().toString(),
	                        business_type: null,
	                        business_id: null
	                    };
	                }
	            } else if (type == TRACK_SUB_TYPE.first) {
	                //首次分享数据类型
	                return {
	                    share_id: share_id_first || _getShareId(),
	                    page_id: page_id,
	                    gmt_action: Date.now().toString(),
	                    share_buyer_id: util._getCookie("WD_b_id") || "",
	                    share_seller_id: util._getCookie("WD_s_id") || "",
	                    share_level: 1,
	                    business_type: null,
	                    business_id: null
	                };
	            } else if (type == TRACK_SUB_TYPE.reshare) {
	                //再次分享数据类型
	                return {
	                    share_id: pathInfo.share_id,
	                    page_id: page_id,
	                    share_buyer_id: pathInfo.share_buyer_id,
	                    reshare_buyer_id: util._getCookie("WD_b_id") || "",
	                    reshare_seller_id: util._getCookie("WD_s_id") || "",
	                    share_level: parseInt(pathInfo.share_level || 0) + 1,
	                    gmt_action: Date.now().toString(),
	                    business_type: null,
	                    business_id: null
	                };
	            } else {
	                return {};
	            }
	        } catch (e) {
	            console.log(e);
	            return {};
	        }
	    }

	    //自动上报通过分享点击的数据内容
	    function _trackByPageView() {
	        try {
	            // core.init("unknown", "unknown", "0.0.0");
	            var option = _getTrackOption(TRACK_SUB_TYPE.click);
	            isDebug && console.log("share_click:", option);
	            if (Object.keys(option).length != 0) {
	                _report(TRACK_SUB_TYPE.click, option);
	            }
	        } catch (e) {
	            console.log(e);
	        }
	    }

	    //上报当前用户主动分享成功的数据内容
	    function _trackByShare(channel) {
	        try {
	            var pathQuery = _getSearchParams(TRAKC_QUERY_NAME);
	            channel = channel || "unknown";
	            if (pathQuery) {
	                //再次分享上报
	                var option = _getTrackOption(TRACK_SUB_TYPE.reshare);
	                option["reshare_channel"] = channel;
	                isDebug && console.log("share_reshare:", option);
	                _report(TRACK_SUB_TYPE.reshare, option);
	            } else {
	                //首次分享上报
	                var option = _getTrackOption(TRACK_SUB_TYPE.first);
	                option["share_channel"] = channel;
	                isDebug && console.log("share_first:", option);
	                _report(TRACK_SUB_TYPE.first, option);
	            }
	        } catch (e) {

	        }


	    }

	    (function () {
	        //微信环境，如果未登录进行静默登录
	        try {
	        // if (util._getCookie('isLogin') != 'true' && navigator.userAgent.toLowerCase().indexOf('micromessenger') != -1) {
	        //     location.href = 'https://sso.weidian.com/user/oauth/wechat/silentlogin?redirect=' + encodeURIComponent(location.href);
	        // } else {
	        // }
	            window.addEventListener("DOMContentLoaded", function (event) {
	                _trackByPageView();
	            });
	        } catch (e) {
	            console.log(e);
	        }

	    })();


	    tracker.version = VERSION;
	    tracker.share = function (option) {
	        try {
	            option = option || {};
	            var url = option.config.url;
	            //修改分享url share_realtion的值
	            if (url) {
	                option.config.url = _getShareUrl(url);
	            }

	            if (typeof option.option === "object") {
	                var _wxCallback = option.option.wxSuccessCb;
	                //修改微信分享成功的回到函数
	                option.option.wxSuccessCb = function (result) {
	                    _trackByShare(result);
	                    if (_wxCallback && typeof _wxCallback == "function") {
	                        _wxCallback(result);
	                    }
	                };
	            } else {
	                option.option = {
	                    wxSuccessCb: function (result) {
	                        _trackByShare(result);
	                    }
	                };
	            }
	            return new Share(option);
	        } catch (e) {
	            console.log(e);
	        }
	    };
	    /*
	    * 生成当前分享的url，
	    * @param url {string} 指定的url
	    * return {string} 带有share_relation关系的url
	    * */
	    tracker.getShareUrl = _getShareUrl;

	    /*
	    * 分享成功,上报数据
	    * @param channel {string} 分享渠道，默认unkonwn
	    * */
	    tracker.successTrack = _trackByShare;
	};
	module.exports = tracker;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	function HttpUrl(url) {

	    //查询串键值对
	    var params = {};
	    Object.defineProperty(this, "params", {
	        get: function () {
	            return params;
	        },
	        set: function (v) {
	            if (typeof v === "object") {
	                for (var k in params) {
	                    delete params[k];
	                }
	                for (var k in v) {
	                    params[k] = v[k];
	                }
	            }
	        },
	        enumberable: false
	    });

	    //参数解析
	    Object.defineProperty(this, "search", {
	        get: function () {
	            var search = [];
	            for (var k in params) {
	                if (params[k] === undefined) {
	                    continue;
	                }
	                if (params[k] !== "") {
	                    try {
	                        search.push(encodeURIComponent(k) + "=" + encodeURIComponent(params[k]));
	                    } catch (e) {
	                        search.push(k + "=" + params[k]);
	                    }
	                } else {
	                    try {
	                        search.push(encodeURIComponent(k));
	                    } catch (e) {
	                        search.push(k);
	                    }
	                }
	            }
	            if (search.length) {
	                return "?" + search.join("&");
	            } else {
	                return "";
	            }
	        },
	        set: function (v) {
	            if (typeof v === "string") {
	                if (v.indexOf("?") === 0) {
	                    v = v.substr(1);
	                }
	                var search = v.split("&");
	                for (var k in params) {
	                    delete params[k];
	                }
	                for (var i = 0; i < search.length; i++) {
	                    var pair = search[i].split("=");
	                    // pair[1] 可能为 0/false/null 等非空但直接运算会返回 false 的值
	                    if (pair[1] !== undefined) {
	                        pair[1] = pair[1].toString();
	                    } else {
	                        pair[1] = "";
	                    }
	                    if (pair[0]) {
	                        try {
	                            params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	                        } catch (e) {
	                            params[pair[0]] = pair[1];
	                        }
	                    }
	                }
	            }
	        },
	        enumberable: true
	    });

	    //hash解析
	    var hash;
	    Object.defineProperty(this, "hash", {
	        set: function (v) {
	            if (typeof v === "string") {
	                if (v && v.indexOf("#") < 0) {
	                    v = "#" + v;
	                }
	                hash = v || "";
	            }
	        },
	        get: function () {
	            return hash;
	        },
	        enumerable: true
	    });

	    this.set = function (v) {
	        v = v || "";
	        var matchArr;
	        var regexpStr = [
	            "^([a-z0-9-]+\:)?",     //protocol
	            "[/]{2}",               //slash x 2
	            "([^:/?#]+)",           //hostname,
	            "(?:[:]([0-9]+))?",     //port,
	            "([/][^?#;]*)?",        //pathname,
	            "(?:[?]([^#]*))?",      //search,
	            "([#][^?]*)?$",         //hash
	        ].join("");

	        if (matchArr = v.match(new RegExp(regexpStr, "i"))) {
	            this.protocol = matchArr[1] || location.protocol;
	            this.hostname = matchArr[2] || "";
	            this.port = matchArr[3] || "";
	            this.pathname = matchArr[4] || "";
	            this.search = matchArr[5] || "";
	            this.hash = matchArr[6] || "";
	            this.origin = this.protocol + "//" + this.hostname;
	        } else {
	            throw new Error("Wrong uri scheme");
	        }
	    };

	    this.toString = function () {
	        var string = this.protocol + "//";
	        string += this.hostname;
	        if (this.port && this.port !== "80") {
	            string += ":" + this.port;
	        }
	        if (this.pathname) {
	            string += this.pathname;
	        }
	        if (this.search) {
	            string += this.search;
	        }
	        if (this.hash) {
	            string += this.hash;
	        }
	        return string;
	    };

	    if (url) {
	        this.set(url.toString());
	    }
	}

	module.exports = HttpUrl;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	!(function(factory) {
	    if (typeof module !== "undefined" && module.exports) {
	        module.exports = factory();
	    } else {
	        window.ShareV2 = factory();
	    }    
	}(function() {
	    var SdkLoader = __webpack_require__(3);
	    var util = __webpack_require__(2);
	    
	    var ua = window.navigator.userAgent;
	    var inWeixin = isInWeixin();
	    var inQQ = isInQQ();
	    var inQQBroswer = isInQQBroswer();

	    var WFR_MAP = {
	        qq: "qfriendh5", 
	        qzone: "qzoneh5", 
	        chats: "wxh5", 
	        moments: "wxph5"
	    };

	    function Share(setting) {
	        var _this = this;

	        SdkLoader().ready(function(env) {
	            _this.env = env;
	            _this._setShareOption(setting.option);  
	            _this._setUserConfig(setting.config);
	            _this._initShareDOM();      
	        });
	    }

	    /**
	     * 默认分享渠道配置参数
	     * @type {{isInApp: boolean, appName: string}}
	     * @scene 卖家版 native 面板渠道
	      {1:微信好友,2:朋友圈,3:qq好友,4:qq空间,5:微博,6复制链接}     
	     * @momentMode 卖家版 native 面板朋友圈分享方式
	      {0:普通分享,1:多图分享,2:大图分享,3:小程序分享}
	     */
	    var defaultOption = {
	        vbuyerShare: true,
	        wdShare: true,
	        scene: [1, 2, 3, 4, 5],
	        prependHtml: "",
	        wxShareTipImge: "",
	        wxSuccessCb: null,
	        hideMenuItems: [],
	        momentMode: 0
	    };

	    Share.prototype._singleShare = function(channel) {
	        if (inQQBroswer) {
	            this._shareInQQBrowser(channel);
	            return;
	        }

	        this.showPanel();
	    };

	    Share.prototype.sharePyq = function() {
	        this._singleShare("moments");
	    };

	    Share.prototype.shareChats = function() {
	        this._singleShare("chats");
	    };

	    Share.prototype.shareQZone = function() {
	        this._singleShare("qzone");
	    };

	    Share.prototype.shareQQ = function() {
	        this._singleShare("qq");
	    };

	    /**
	     * 对外接口，用来重设分享配置
	     */
	    Share.prototype.resetShareOption = function (option) {
	        var newOption = assgin(option, this.option);
	        this._setShareOption(newOption);      
	        this._initShareDOM(true);
	    };

	    /**
	     * 对外接口，用来重设用户分享信息
	     */
	    Share.prototype.resetUserConfig = function(config, notSyncTopRight) {
	        var _this = this;
	        //merge参数
	        SdkLoader().ready(function (env) {
	            var newConfig = assgin(config, _this.config);
	            _this._setUserConfig(newConfig);

	            // todo
	            if (env === "wx") {
	                _this._setWXMenuEvent();
	            }

	            // 需要jsbridge 加载完毕
	            if (env === "vbuyer" && window.KDJSBridge2 !== undefined && _this.option.vbuyerShare && !notSyncTopRight) { 
	                _this._showVbuyerShare();
	            }

	            if (env === "kdweidian" && window.KDJSBridge2 !== undefined && _this.option.wdShare && !notSyncTopRight) {
	                _this._showWDShare();
	            } 
	        });
	    };

	    /**
	     * 对外接口,直接显示分享面板
	     */
	    Share.prototype.showPanel = function() {
	        var self = this;
	        var config = self.config;

	        if (this.option.isInApp !== false ) {
	            this._showNativeShare();

	        } else {
	            this.option.$dom.style.display = "block";
	            document.body.classList.add("ui-share__hidden");
	            document.querySelector(".copy-href") && (document.querySelector(".copy-href").value = this.config.url);
	        }
	    };

	    /**
	     * 根据当前环境，配置参数
	     * @private
	     */
	    Share.prototype._setShareOption = function (option) {
	        var self = this,
	            newOption = {};
	        
	        newOption.appContainer = this.env;
	        newOption.isInApp = (this.env === "vbuyer" || this.env === "kdweidian" || this.env === "app");

	        if (option && option.vbuyerShare !== undefined) {
	            newOption.vbuyerShare = option.vbuyerShare;
	        } else {
	            newOption.vbuyerShare = defaultOption.vbuyerShare;
	        }        

	        if (option && option.wdShare !== undefined) {
	            newOption.wdShare = option.wdShare;
	        } else {
	            newOption.wdShare = defaultOption.wdShare;
	        }

	        if (option && option.scene !== undefined && option.scene.length > 0) {
	            newOption.scene = option.scene;

	        } else {
	            newOption.scene = defaultOption.scene;
	        }
	        
	        newOption.wxShareTipImge = (option && option.wxShareTipImge) || defaultOption.wxShareTipImge;
	        newOption.wxSuccessCb = (option && option.wxSuccessCb) || defaultOption.wxSuccessCb;
	        newOption.hideMenuItems = (option && option.hideMenuItems) || defaultOption.hideMenuItems;
	        newOption.momentMode = (option && option.momentMode) || defaultOption.momentMode;

	        newOption.$dom = self.option && self.option.$dom;

	        newOption.prependHtml = (option && option.prependHtml !== undefined) ? option.prependHtml : defaultOption.prependHtml;

	        self.option = newOption;
	    };

	    /**
	     * 配置用户分享信息
	     * @private
	     */
	    Share.prototype._setUserConfig = function (config) {
	        this.config = {};
	        var shareConfig = config;
	        shareConfig.pyq = shareConfig.pyq || shareConfig.title;

	        if (Object.getOwnPropertyNames(shareConfig).length > 0) {
	            for (var key in shareConfig) {
	                this["config"][key] = shareConfig[key];
	            }
	        }
	    };

	    /**
	     * 初始化分享DOM结构
	     * @private
	     */
	    Share.prototype._initShareDOM = function (isReset) {
	        var option = this.option;

	        if (isReset) {
	            if (inQQ || inWeixin) {
	                option.$dom.innerHTML = this._renderShareTip();
	            } else if (inQQBroswer) {
	                option.$dom.innerHTML = this._renderSharePanel();
	            } else {
	                option.$dom.innerHTML = this._renderCopyPanel();
	            }
	            this._bindEvent();
	            return;
	        }
	        var shareBox = document.createElement("div");
	        shareBox.id = "ui-share-box";
	        shareBox.style.display = "none";
	        shareBox.dataset.spider = "share";
	        this.option.$dom = shareBox;

	        if (inQQ) {                 //在QQ中
	            shareBox.innerHTML = this._renderShareTip();
	            this._initQQShare();

	        } else if (inWeixin) {    //在微信中
	            shareBox.innerHTML = this._renderShareTip();
	            this._setWXMenuEvent();

	        } else if (inQQBroswer) {  //在QQ浏览器中
	            shareBox.innerHTML = this._renderSharePanel();
	        } else if (option.isInApp) {
	            this._showCornerShare(option.appContainer);

	        } else {
	            shareBox.innerHTML = this._renderCopyPanel();
	        }

	        document.body.appendChild(shareBox);
	        this._bindEvent();
	    };

	    Share.prototype._initQQShare = function() {
	        var self = this,
	            config = {
	                title: self.config.title,
	                desc: self.config.content,
	                share_url: _coverUrlWfr(self.config.url, "qfriendh5"),
	                image_url: self.config.img
	            };
	        window.mqq.data.setShareInfo(config);
	    };

	    Share.prototype._setWXMenuEvent = function() {
	        if (!window.wx) return;

	        //分享给朋友
	        window.wx.onMenuShareAppMessage(this._setWeixinConfig("chats"));

	        //分享到朋友圈
	        window.wx.onMenuShareTimeline(this._setWeixinConfig("moments"));

	        //分享到QQ
	        window.wx.onMenuShareQQ(this._setWeixinConfig("qq"));

	        //分享到QQ空间
	        window.wx.onMenuShareQZone(this._setWeixinConfig("qzone"));

	        //隐藏部分菜单按钮
	        if (this.option.hideMenuItems.length > 0) {
	            window.wx.hideMenuItems(this._setHideMenuItem());
	        }
	    };

	    Share.prototype._setHideMenuItem = function() {
	        var hideMenuItems = this.option.hideMenuItems;
	        var menuList = [];
	        var shareIndex = hideMenuItems.indexOf("share");
	        var protectIndex = hideMenuItems.indexOf("protect");
	        if (shareIndex > -1) {
	            [].push.apply(menuList, ["menuItem:share:appMessage", "menuItem:share:timeline", "menuItem:share:qq", "menuItem:share:weiboApp", "menuItem:favorite", "menuItem:share:facebook", "menuItem:share:QZone"]);
	            hideMenuItems.splice(shareIndex, 1);
	        }

	        if (protectIndex > -1) {
	            [].push.apply(menuList, ["menuItem:editTag", "menuItem:delete", "menuItem:copyUrl", "menuItem:originPage", "menuItem:readMode", "menuItem:openWithQQBrowser", "menuItem:openWithSafari", "menuItem:share:email"]);
	            hideMenuItems.splice(protectIndex, 1);
	        }

	        [].push.apply(menuList, hideMenuItems);
	        if (menuList.length > 0) {
	            return {menuList: menuList};
	        }
	        
	        return {}; 
	    };

	    /**
	     * 微信分享参数设置
	     * @param way
	     * @returns {{title: string, desc: string, link: string, imgUrl: string, trigger: param.trigger, fail: param.fail}}
	     * @private
	     */
	    Share.prototype._setWeixinConfig = function(channel) {
	        var self = this,
	            channels = {
	                chats: "分享给微信好友",
	                moments: "分享到朋友圈",
	                qq: "分享给qq好友",
	                qzone: "分享到qq空间",
	            },
	            wfr = WFR_MAP[channel],
	            param = {
	                title: self.config.title,
	                desc: self.config.content,
	                link: _coverUrlWfr(self.config.url, wfr),
	                imgUrl: self.config.img,
	                trigger: function (res) {
	                    if (window.spider) {
	                        spider.trackAction({
	                            actionName: "_share",
	                            actionArgs: {
	                                channel: channels[channel].slice(3)
	                            }
	                        });
	                    }
	                },
	                success: function() {
	                    self.option.wxSuccessCb && self.option.wxSuccessCb(wfr);
	                }
	            };

	        if (channel && (channel === "moments")) {
	            delete param.desc;
	            if (channel === "moments") param.title = self.config.pyq;
	        }

	        return param;
	    };

	    /**
	     * 微信模板
	     * @returns {string}
	     */
	    Share.prototype._renderShareTip = function() {
	        return '<a href="javascript:;" class="ui-share__placeholder J_closed"></a>' +
	            '<a href="javascript:;" class="ui-share--weixin J_closed">' +
	            '<img src="' + (this.option.wxShareTipImge? this.option.wxShareTipImge : 'https://si.geilicdn.com/110c5d9454010c64fc4366d75230a729.png') + '"></a>';    
	    };

	    /**
	     * 其他模板
	     * @returns {string}
	     */
	    Share.prototype._renderSharePanel = function () {
	        var html = "";
	        var scene = this.option.scene;

	        if (scene.indexOf(1) >= 0) {
	            html += '<a href="javascript:;" class="ui-share--icon J_channel" scene="0" type="weixin" channel="chats" spm-auto data-spider="dsharechats">' +
	                '<img src="https://si.geilicdn.com/hz_img_032100000158d24945100a02685e_48_48_unadjust.png">' +
	                '<p>微信好友</p>' +
	                '</a>';
	        }

	        if (scene.indexOf(2) >= 0) {
	            html += '<a href="javascript:;" class="ui-share--icon J_channel" scene="1" type="weixin" channel="moments" spm-auto data-spider="dsharemoments">' +
	                '<img src="https://si.geilicdn.com/hz_img_033300000158d26282d20a02685e_48_48_unadjust.png">' +
	                '<p>朋友圈</p>' +
	                '</a>';
	        }

	        if (scene.indexOf(3) >= 0 ) {
	            html += '<a href="javascript:;" class="ui-share--icon J_channel" type="qq" scene="0" channel="qq" spm-auto data-spider="dshareqq">' +
	                '<img src="https://si.geilicdn.com/hz_img_136f00000158d26814dc0a026860_48_48_unadjust.png">' +
	                '<p>QQ好友</p>' +
	                '</a>';
	        }

	        if (scene.indexOf(4) >= 0 ) {
	            html += '<a href="javascript:;" class="ui-share--icon J_channel" type="qq" scene="1" channel="qzone" spm-auto data-spider="dshareqzone">' +
	                '<img src="https://si.geilicdn.com/hz_img_030900000158d22b05690a02685e_48_48_unadjust.png">' +
	                '<p>QQ空间</p>' +
	                '</a>';
	        }
	        return '<a href="javascript:;" class="ui-share__placeholder J_closed"></a>' +
	            '<section class="ui-share">' +
	            '<div class="ui-share--panel">' + this.option.prependHtml + html +
	            '</div><a href="javascript:;" class="ui-share--closed J_closed">取消</a>' + 
	            '</section>';
	    };

	    Share.prototype._renderCopyPanel = function() {
	        return '<a href="javascript:;" class="ui-share__placeholder J_closed"></a>' +
	            '<section class="ui-share">' +
	            '<div class="ui-share--panel">' +
	            '<div class="ui-share-copy">' +
	            '<p>长按复制下方链接，去粘贴给好友吧</p>' +
	            '<input class="copy-href" type="text">' +
	            '</div>' +
	            '</div><a href="javascript:;" class="ui-share--closed J_closed">取消</a>' + 
	            '</section>';
	    };

	    Share.prototype._showCornerShare = function(appName) {
	        var self = this;

	        if (appName === "vbuyer" && self.option.vbuyerShare) {
	            self._showVbuyerShare();
	        } else if (appName === "kdweidian" && self.option.wdShare) {
	            self._showWDShare();
	        }
	    };

	    Share.prototype._showVbuyerShare = function () {
	        var config = this.config;
	        var option = this.option;

	        window.KDJSBridge2 && window.KDJSBridge2.call("Share", "showOption", {
	            "title": config.title,
	            "content": config.content,
	            "content_ext": config.pyq,
	            "url":config.img,
	            "cmd":config.url,
	            "scene": option.scene,
	            "src": location.href
	        }, function(res) {});  
	    };

	    Share.prototype._showWDShare = function() {
	        var config = this.config;
	        var option = this.option;

	        window.KDJSBridge2 && window.KDJSBridge2.call("WDJSBridge", "share", {
	            "title": config.title,
	            "content": config.content,
	            "content_ext": config.pyq,
	            "url":config.img,
	            "cmd":config.url,
	            "mini_path": config.path,
	            "mini_id": config.id,
	            "mini_withShareTicket": "1",
	            "mini_programType": config.miniType,
	            "img_urls": config.img_urls,
	            "moments_mode": option.momentMode,
	            "scene": option.scene,
	            "action_immediately": 0,
	        }, function(res) {});
	    };

	    /**
	     * 绑定事件
	     */
	    Share.prototype._bindEvent = function () {
	        var self = this;
	        var closed = document.querySelectorAll(".J_closed");
	        var channel = document.querySelectorAll(".J_channel");
	        var invoking = false;

	        for (var i = 0; i < closed.length; i++) {
	            closed[i].addEventListener("click", function() {
	                invoking = false;
	                self.option.$dom.style.display = "none";
	                document.body.classList.remove("ui-share__hidden");
	            });
	        }

	        for (var k = 0; k < channel.length; k++) {
	            channel[k].addEventListener("click", function() {
	                if (invoking == true) return;
	                var channel = this.getAttribute("channel");
	                self._shareInQQBrowser(channel);
	                invoking = true;

	                setTimeout(function() {
	                    invoking = false;
	                }, 5000);
	            });
	        }
	    };

	    /**
	     * 调用QQ浏览器分享服务
	     * @private
	     */
	    Share.prototype._shareInQQBrowser = function (channel) {     
	        var curConfig = this.config,
	            map = {qq: 4, qzone: 3, chats: 1, moments: 8},
	            toApp = map[channel],
	            wfr = WFR_MAP[channel];

	        var url = _coverUrlWfr(curConfig.url, wfr);
	        var config = {
	            url: url,
	            title: curConfig.title,
	            description: curConfig.content,
	            img_url: curConfig.img,
	            to_app: toApp, //微信好友1,腾讯微博2,QQ空间3,QQ好友4,生成二维码7,微信朋友圈8,啾啾分享9,复制网址10,分享到微博11,创意分享13
	        };
	        if (toApp == 8) {
	            config.title = curConfig.pyq;
	        }
	        browser.app.share(config);
	    };

	    /**
	     * 调用native分享
	     * @private
	     */
	    Share.prototype._showNativeShare = function() {
	        var config = this.config;
	        var option = this.option;

	        window.KDJSBridge2 && window.KDJSBridge2.call("WDJSBridge", "share", {
	            "title": config.title,
	            "content": config.content,
	            "content_ext": config.pyq,
	            "url":config.img,
	            "cmd":config.url,
	            "mini_path": config.path,
	            "mini_id": config.id,
	            "mini_withShareTicket": "1",
	            "mini_programType": config.miniType,
	            "img_urls": config.img_urls,
	            "moments_mode": option.momentMode,
	            "scene": option.scene
	        }, function(res) {});
	    };

	    /**
	     * 克隆对象或分配对象
	     * @param obj
	     * @returns {object}
	     * @private
	     */
	    function assgin(target){
	        var sourceArray = [].slice.call(arguments, 1);
	        sourceArray.forEach(function (source) {
	            for(var key in source){
	                if(source.hasOwnProperty(key) && !target.hasOwnProperty(key)){
	                    target[key] = source[key];
	                }
	            }  
	        })
	        return target;
	    }

	    function _coverUrlWfr(url, wfr) {
	        var parsedUrl = util._urlParse(url);
	        var hash = parsedUrl.hash;

	        var inheritWfr = util._queryStringParse(location.search).wfr;
	        if (!inheritWfr) {
	            inheritWfr = "h5direct";
	        } else {
	            Object.keys(WFR_MAP).forEach(function (channel) {
	                var wfr = WFR_MAP[channel];
	                inheritWfr = inheritWfr.replace("_" + wfr, "");
	            });
	        }

	        var queryParam = util._queryStringParse(parsedUrl.search);
	        queryParam.wfr = inheritWfr + "_" + wfr;

	        var querystring = util._queryStringStringify(queryParam);
	        return url.replace(/(\?|#)[\S]*$/, "") + "?" + querystring + hash;
	    }

	    function isInWeixin() {
	        return /MicroMessenger/i.test(ua);
	    }

	    function isInQQ() {
	        return /QQ\/([\d\.]+)/i.test(ua);
	    }

	    function isInQQBroswer() {
	        return /MQQBrowser\//i.test(ua) && !isInQQ();
	    }


	    return Share;
	}));

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(19);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;

	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(21)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!./share.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!./share.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(20)(false);
	// imports


	// module
	exports.push([module.id, "#ui-share-box{display:none}#ui-share-box a{text-decoration:none}.ui-share__placeholder{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.8);z-index:10}.ui-share__hidden{overflow:hidden}.ui-share--weixin{position:fixed;top:0;left:0;width:100%;height:100%;z-index:10}.ui-share--weixin>img{width:100%}.ui-share{width:100%;position:fixed;left:0;bottom:0;background:#ededed;overflow:hidden;z-index:20}.ui-share--panel{background:#fff;font-size:0;text-align:center}.ui-share--icon{width:25%;display:inline-block;text-align:center;margin-top:.6rem;margin-bottom:.6rem}.ui-share--icon:nth-of-type(5n){margin-top:0}.ui-share--icon>img{width:2.5rem}.ui-share--icon>p{font-size:.8rem;color:#222;margin-top:.2rem}.ui-share--closed{background:#fff;font-size:1.2rem;text-align:center;padding:.6rem 0;color:#ee3431;display:block;margin-top:.4rem}.ui-share--tips{margin:0;background:#fff;font-size:.8rem;color:#bbb;text-align:center;padding:.3rem 0}.ui-share-copy{padding:.625rem .625rem;overflow:hidden;text-align:left}.ui-share-copy>input{font-size:.78125rem;padding:.15625rem;width:90%;border:1px solid #ccc}.ui-share-copy>p{font-size:.8rem;color:#222;margin:0 0 .5rem}", ""]);

	// exports


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function(useSourceMap) {
		var list = [];

		// return the list of modules as css string
		list.toString = function toString() {
			return this.map(function (item) {
				var content = cssWithMappingToString(item, useSourceMap);
				if(item[2]) {
					return "@media " + item[2] + "{" + content + "}";
				} else {
					return content;
				}
			}).join("");
		};

		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};

	function cssWithMappingToString(item, useSourceMap) {
		var content = item[1] || '';
		var cssMapping = item[3];
		if (!cssMapping) {
			return content;
		}

		if (useSourceMap && typeof btoa === 'function') {
			var sourceMapping = toComment(cssMapping);
			var sourceURLs = cssMapping.sources.map(function (source) {
				return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
			});

			return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
		}

		return [content].join('\n');
	}

	// Adapted from convert-source-map (MIT)
	function toComment(sourceMap) {
		// eslint-disable-next-line no-undef
		var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
		var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

		return '/*# ' + data + ' */';
	}


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/

	var stylesInDom = {};

	var	memoize = function (fn) {
		var memo;

		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	};

	var isOldIE = memoize(function () {
		// Test for IE <= 9 as proposed by Browserhacks
		// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
		// Tests for existence of standard globals is to allow style-loader
		// to operate correctly into non-standard environments
		// @see https://github.com/webpack-contrib/style-loader/issues/177
		return window && document && document.all && !window.atob;
	});

	var getElement = (function (fn) {
		var memo = {};

		return function(selector) {
			if (typeof memo[selector] === "undefined") {
				memo[selector] = fn.call(this, selector);
			}

			return memo[selector]
		};
	})(function (target) {
		return document.querySelector(target)
	});

	var singleton = null;
	var	singletonCounter = 0;
	var	stylesInsertedAtTop = [];

	var	fixUrls = __webpack_require__(22);

	module.exports = function(list, options) {
		if (false) {
			if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}

		options = options || {};

		options.attrs = typeof options.attrs === "object" ? options.attrs : {};

		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (!options.singleton) options.singleton = isOldIE();

		// By default, add <style> tags to the <head> element
		if (!options.insertInto) options.insertInto = "head";

		// By default, add <style> tags to the bottom of the target
		if (!options.insertAt) options.insertAt = "bottom";

		var styles = listToStyles(list, options);

		addStylesToDom(styles, options);

		return function update (newList) {
			var mayRemove = [];

			for (var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];

				domStyle.refs--;
				mayRemove.push(domStyle);
			}

			if(newList) {
				var newStyles = listToStyles(newList, options);
				addStylesToDom(newStyles, options);
			}

			for (var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];

				if(domStyle.refs === 0) {
					for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

					delete stylesInDom[domStyle.id];
				}
			}
		};
	};

	function addStylesToDom (styles, options) {
		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			if(domStyle) {
				domStyle.refs++;

				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}

				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];

				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}

				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}

	function listToStyles (list, options) {
		var styles = [];
		var newStyles = {};

		for (var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = options.base ? item[0] + options.base : item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};

			if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
			else newStyles[id].parts.push(part);
		}

		return styles;
	}

	function insertStyleElement (options, style) {
		var target = getElement(options.insertInto)

		if (!target) {
			throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
		}

		var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

		if (options.insertAt === "top") {
			if (!lastStyleElementInsertedAtTop) {
				target.insertBefore(style, target.firstChild);
			} else if (lastStyleElementInsertedAtTop.nextSibling) {
				target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				target.appendChild(style);
			}
			stylesInsertedAtTop.push(style);
		} else if (options.insertAt === "bottom") {
			target.appendChild(style);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}

	function removeStyleElement (style) {
		if (style.parentNode === null) return false;
		style.parentNode.removeChild(style);

		var idx = stylesInsertedAtTop.indexOf(style);
		if(idx >= 0) {
			stylesInsertedAtTop.splice(idx, 1);
		}
	}

	function createStyleElement (options) {
		var style = document.createElement("style");

		options.attrs.type = "text/css";

		addAttrs(style, options.attrs);
		insertStyleElement(options, style);

		return style;
	}

	function createLinkElement (options) {
		var link = document.createElement("link");

		options.attrs.type = "text/css";
		options.attrs.rel = "stylesheet";

		addAttrs(link, options.attrs);
		insertStyleElement(options, link);

		return link;
	}

	function addAttrs (el, attrs) {
		Object.keys(attrs).forEach(function (key) {
			el.setAttribute(key, attrs[key]);
		});
	}

	function addStyle (obj, options) {
		var style, update, remove, result;

		// If a transform function was defined, run it on the css
		if (options.transform && obj.css) {
		    result = options.transform(obj.css);

		    if (result) {
		    	// If transform returns a value, use that instead of the original css.
		    	// This allows running runtime transformations on the css.
		    	obj.css = result;
		    } else {
		    	// If the transform function returns a falsy value, don't add this css.
		    	// This allows conditional loading of css
		    	return function() {
		    		// noop
		    	};
		    }
		}

		if (options.singleton) {
			var styleIndex = singletonCounter++;

			style = singleton || (singleton = createStyleElement(options));

			update = applyToSingletonTag.bind(null, style, styleIndex, false);
			remove = applyToSingletonTag.bind(null, style, styleIndex, true);

		} else if (
			obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function"
		) {
			style = createLinkElement(options);
			update = updateLink.bind(null, style, options);
			remove = function () {
				removeStyleElement(style);

				if(style.href) URL.revokeObjectURL(style.href);
			};
		} else {
			style = createStyleElement(options);
			update = applyToTag.bind(null, style);
			remove = function () {
				removeStyleElement(style);
			};
		}

		update(obj);

		return function updateStyle (newObj) {
			if (newObj) {
				if (
					newObj.css === obj.css &&
					newObj.media === obj.media &&
					newObj.sourceMap === obj.sourceMap
				) {
					return;
				}

				update(obj = newObj);
			} else {
				remove();
			}
		};
	}

	var replaceText = (function () {
		var textStore = [];

		return function (index, replacement) {
			textStore[index] = replacement;

			return textStore.filter(Boolean).join('\n');
		};
	})();

	function applyToSingletonTag (style, index, remove, obj) {
		var css = remove ? "" : obj.css;

		if (style.styleSheet) {
			style.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = style.childNodes;

			if (childNodes[index]) style.removeChild(childNodes[index]);

			if (childNodes.length) {
				style.insertBefore(cssNode, childNodes[index]);
			} else {
				style.appendChild(cssNode);
			}
		}
	}

	function applyToTag (style, obj) {
		var css = obj.css;
		var media = obj.media;

		if(media) {
			style.setAttribute("media", media)
		}

		if(style.styleSheet) {
			style.styleSheet.cssText = css;
		} else {
			while(style.firstChild) {
				style.removeChild(style.firstChild);
			}

			style.appendChild(document.createTextNode(css));
		}
	}

	function updateLink (link, options, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;

		/*
			If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
			and there is no publicPath defined then lets turn convertToAbsoluteUrls
			on by default.  Otherwise default to the convertToAbsoluteUrls option
			directly
		*/
		var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

		if (options.convertToAbsoluteUrls || autoFixUrls) {
			css = fixUrls(css);
		}

		if (sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}

		var blob = new Blob([css], { type: "text/css" });

		var oldSrc = link.href;

		link.href = URL.createObjectURL(blob);

		if(oldSrc) URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	
	/**
	 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
	 * embed the css on the page. This breaks all relative urls because now they are relative to a
	 * bundle instead of the current page.
	 *
	 * One solution is to only use full urls, but that may be impossible.
	 *
	 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
	 *
	 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
	 *
	 */

	module.exports = function (css) {
	  // get current location
	  var location = typeof window !== "undefined" && window.location;

	  if (!location) {
	    throw new Error("fixUrls requires window.location");
	  }

		// blank or null?
		if (!css || typeof css !== "string") {
		  return css;
	  }

	  var baseUrl = location.protocol + "//" + location.host;
	  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

		// convert each url(...)
		/*
		This regular expression is just a way to recursively match brackets within
		a string.

		 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
		   (  = Start a capturing group
		     (?:  = Start a non-capturing group
		         [^)(]  = Match anything that isn't a parentheses
		         |  = OR
		         \(  = Match a start parentheses
		             (?:  = Start another non-capturing groups
		                 [^)(]+  = Match anything that isn't a parentheses
		                 |  = OR
		                 \(  = Match a start parentheses
		                     [^)(]*  = Match anything that isn't a parentheses
		                 \)  = Match a end parentheses
		             )  = End Group
	              *\) = Match anything and then a close parens
	          )  = Close non-capturing group
	          *  = Match anything
	       )  = Close capturing group
		 \)  = Match a close parens

		 /gi  = Get all matches, not the first.  Be case insensitive.
		 */
		var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
			// strip quotes (if they exist)
			var unquotedOrigUrl = origUrl
				.trim()
				.replace(/^"(.*)"$/, function(o, $1){ return $1; })
				.replace(/^'(.*)'$/, function(o, $1){ return $1; });

			// already a full url? no change
			if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
			  return fullMatch;
			}

			// convert the url to a full url
			var newUrl;

			if (unquotedOrigUrl.indexOf("//") === 0) {
			  	//TODO: should we add protocol?
				newUrl = unquotedOrigUrl;
			} else if (unquotedOrigUrl.indexOf("/") === 0) {
				// path should be relative to the base url
				newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
			} else {
				// path should be relative to current directory
				newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
			}

			// send back the fixed url(...)
			return "url(" + JSON.stringify(newUrl) + ")";
		});

		// send back the fixed css
		return fixedCss;
	};


/***/ })
/******/ ]);